import { jsx as W, jsxs as Oe, Fragment as rr } from "react/jsx-runtime";
import F, { useState as zt, useRef as Le, useLayoutEffect as Pr, useEffect as ze, useSyncExternalStore as wo, isValidElement as Vt, cloneElement as In, createContext as Oo, useContext as Ro, useReducer as ko, useCallback as ct, useMemo as Io } from "react";
import { styled as te, createGlobalStyle as No } from "styled-components";
import Ot from "react-dom";
function Dr(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number") r += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var o = t.length;
    for (e = 0; e < o; e++) t[e] && (n = Dr(t[e])) && (r && (r += " "), r += n);
  } else for (n in t) t[n] && (r && (r += " "), r += n);
  return r;
}
function je() {
  for (var t, e, n = 0, r = "", o = arguments.length; n < o; n++) (t = arguments[n]) && (e = Dr(t)) && (r && (r += " "), r += e);
  return r;
}
function Mo(t) {
  if (typeof document > "u") return;
  let e = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", e.firstChild ? e.insertBefore(n, e.firstChild) : e.appendChild(n), n.styleSheet ? n.styleSheet.cssText = t : n.appendChild(document.createTextNode(t));
}
Mo(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var At = (t) => typeof t == "number" && !isNaN(t), qe = (t) => typeof t == "string", Pe = (t) => typeof t == "function", Lo = (t) => qe(t) || At(t), gn = (t) => qe(t) || Pe(t) ? t : null, Po = (t, e) => t === !1 || At(t) && t > 0 ? t : e, yn = (t) => Vt(t) || qe(t) || Pe(t) || At(t);
function Do(t, e, n = 300) {
  let { scrollHeight: r, style: o } = t;
  requestAnimationFrame(() => {
    o.minHeight = "initial", o.height = r + "px", o.transition = `all ${n}ms`, requestAnimationFrame(() => {
      o.height = "0", o.padding = "0", o.margin = "0", setTimeout(e, n);
    });
  });
}
function Bo({ enter: t, exit: e, appendPosition: n = !1, collapse: r = !0, collapseDuration: o = 300 }) {
  return function({ children: s, position: i, preventExitTransition: a, done: l, nodeRef: f, isIn: u, playToast: g }) {
    let T = n ? `${t}--${i}` : t, R = n ? `${e}--${i}` : e, P = Le(0);
    return Pr(() => {
      let O = f.current, v = T.split(" "), x = (p) => {
        p.target === f.current && (g(), O.removeEventListener("animationend", x), O.removeEventListener("animationcancel", x), P.current === 0 && p.type !== "animationcancel" && O.classList.remove(...v));
      };
      O.classList.add(...v), O.addEventListener("animationend", x), O.addEventListener("animationcancel", x);
    }, []), ze(() => {
      let O = f.current, v = () => {
        O.removeEventListener("animationend", v), r ? Do(O, l, o) : l();
      };
      u || (a ? v() : (P.current = 1, O.className += ` ${R}`, O.addEventListener("animationend", v)));
    }, [u]), F.createElement(F.Fragment, null, s);
  };
}
function or(t, e) {
  return { content: Br(t.content, t.props), containerId: t.props.containerId, id: t.props.toastId, theme: t.props.theme, type: t.props.type, data: t.props.data || {}, isLoading: t.props.isLoading, icon: t.props.icon, reason: t.removalReason, status: e };
}
function Br(t, e, n = !1) {
  return Vt(t) && !qe(t.type) ? In(t, { closeToast: e.closeToast, toastProps: e, data: e.data, isPaused: n }) : Pe(t) ? t({ closeToast: e.closeToast, toastProps: e, data: e.data, isPaused: n }) : t;
}
function Wo({ closeToast: t, theme: e, ariaLabel: n = "close" }) {
  return F.createElement("button", { className: `Toastify__close-button Toastify__close-button--${e}`, type: "button", onClick: (r) => {
    r.stopPropagation(), t(!0);
  }, "aria-label": n }, F.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, F.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function zo({ delay: t, isRunning: e, closeToast: n, type: r = "default", hide: o, className: s, controlledProgress: i, progress: a, rtl: l, isIn: f, theme: u }) {
  let g = o || i && a === 0, T = { animationDuration: `${t}ms`, animationPlayState: e ? "running" : "paused" };
  i && (T.transform = `scaleX(${a})`);
  let R = je("Toastify__progress-bar", i ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${u}`, `Toastify__progress-bar--${r}`, { "Toastify__progress-bar--rtl": l }), P = Pe(s) ? s({ rtl: l, type: r, defaultClassName: R }) : je(R, s), O = { [i && a >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: i && a < 1 ? null : () => {
    f && n();
  } };
  return F.createElement("div", { className: "Toastify__progress-bar--wrp", "data-hidden": g }, F.createElement("div", { className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${u} Toastify__progress-bar--${r}` }), F.createElement("div", { role: "progressbar", "aria-hidden": g ? "true" : "false", "aria-label": "notification timer", className: P, style: T, ...O }));
}
var Uo = 1, Wr = () => `${Uo++}`;
function Vo(t, e, n) {
  let r = 1, o = 0, s = [], i = [], a = e, l = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Set(), u = (p) => (f.add(p), () => f.delete(p)), g = () => {
    i = Array.from(l.values()), f.forEach((p) => p());
  }, T = ({ containerId: p, toastId: y, updateId: E }) => {
    let d = p ? p !== t : t !== 1, K = l.has(y) && E == null;
    return d || K;
  }, R = (p, y) => {
    l.forEach((E) => {
      var d;
      (y == null || y === E.props.toastId) && ((d = E.toggle) == null || d.call(E, p));
    });
  }, P = (p) => {
    var y, E;
    (E = (y = p.props) == null ? void 0 : y.onClose) == null || E.call(y, p.removalReason), p.isActive = !1;
  }, O = (p) => {
    if (p == null) l.forEach(P);
    else {
      let y = l.get(p);
      y && P(y);
    }
    g();
  }, v = () => {
    o -= s.length, s = [];
  }, x = (p) => {
    var y, E;
    let { toastId: d, updateId: K } = p.props, B = K == null;
    p.staleId && l.delete(p.staleId), p.isActive = !0, l.set(d, p), g(), n(or(p, B ? "added" : "updated")), B && ((E = (y = p.props).onOpen) == null || E.call(y));
  };
  return { id: t, props: a, observe: u, toggle: R, removeToast: O, toasts: l, clearQueue: v, buildToast: (p, y) => {
    if (T(y)) return;
    let { toastId: E, updateId: d, data: K, staleId: B, delay: H } = y, ne = d == null;
    ne && o++;
    let pe = { ...a, style: a.toastStyle, key: r++, ...Object.fromEntries(Object.entries(y).filter(([ie, ye]) => ye != null)), toastId: E, updateId: d, data: K, isIn: !1, className: gn(y.className || a.toastClassName), progressClassName: gn(y.progressClassName || a.progressClassName), autoClose: y.isLoading ? !1 : Po(y.autoClose, a.autoClose), closeToast(ie) {
      l.get(E).removalReason = ie, O(E);
    }, deleteToast() {
      let ie = l.get(E);
      if (ie != null) {
        if (n(or(ie, "removed")), l.delete(E), o--, o < 0 && (o = 0), s.length > 0) {
          x(s.shift());
          return;
        }
        g();
      }
    } };
    pe.closeButton = a.closeButton, y.closeButton === !1 || yn(y.closeButton) ? pe.closeButton = y.closeButton : y.closeButton === !0 && (pe.closeButton = yn(a.closeButton) ? a.closeButton : !0);
    let j = { content: p, props: pe, staleId: B };
    a.limit && a.limit > 0 && o > a.limit && ne ? s.push(j) : At(H) ? setTimeout(() => {
      x(j);
    }, H) : x(j);
  }, setProps(p) {
    a = p;
  }, setToggle: (p, y) => {
    let E = l.get(p);
    E && (E.toggle = y);
  }, isToastActive: (p) => {
    var y;
    return (y = l.get(p)) == null ? void 0 : y.isActive;
  }, getSnapshot: () => i };
}
var fe = /* @__PURE__ */ new Map(), yt = [], An = /* @__PURE__ */ new Set(), Go = (t) => An.forEach((e) => e(t)), zr = () => fe.size > 0;
function Ho() {
  yt.forEach((t) => Vr(t.content, t.options)), yt = [];
}
var Fo = (t, { containerId: e }) => {
  var n;
  return (n = fe.get(e || 1)) == null ? void 0 : n.toasts.get(t);
};
function Ur(t, e) {
  var n;
  if (e) return !!((n = fe.get(e)) != null && n.isToastActive(t));
  let r = !1;
  return fe.forEach((o) => {
    o.isToastActive(t) && (r = !0);
  }), r;
}
function jo(t) {
  if (!zr()) {
    yt = yt.filter((e) => t != null && e.options.toastId !== t);
    return;
  }
  if (t == null || Lo(t)) fe.forEach((e) => {
    e.removeToast(t);
  });
  else if (t && ("containerId" in t || "id" in t)) {
    let e = fe.get(t.containerId);
    e ? e.removeToast(t.id) : fe.forEach((n) => {
      n.removeToast(t.id);
    });
  }
}
var qo = (t = {}) => {
  fe.forEach((e) => {
    e.props.limit && (!t.containerId || e.id === t.containerId) && e.clearQueue();
  });
};
function Vr(t, e) {
  yn(t) && (zr() || yt.push({ content: t, options: e }), fe.forEach((n) => {
    n.buildToast(t, e);
  }));
}
function Yo(t) {
  var e;
  (e = fe.get(t.containerId || 1)) == null || e.setToggle(t.id, t.fn);
}
function Gr(t, e) {
  fe.forEach((n) => {
    (e == null || !(e != null && e.containerId) || (e == null ? void 0 : e.containerId) === n.id) && n.toggle(t, e == null ? void 0 : e.id);
  });
}
function Zo(t) {
  let e = t.containerId || 1;
  return { subscribe(n) {
    let r = Vo(e, t, Go);
    fe.set(e, r);
    let o = r.observe(n);
    return Ho(), () => {
      o(), fe.delete(e);
    };
  }, setProps(n) {
    var r;
    (r = fe.get(e)) == null || r.setProps(n);
  }, getSnapshot() {
    var n;
    return (n = fe.get(e)) == null ? void 0 : n.getSnapshot();
  } };
}
function Ko(t) {
  return An.add(t), () => {
    An.delete(t);
  };
}
function Jo(t) {
  return t && (qe(t.toastId) || At(t.toastId)) ? t.toastId : Wr();
}
function Et(t, e) {
  return Vr(t, e), e.toastId;
}
function Gt(t, e) {
  return { ...e, type: e && e.type || t, toastId: Jo(e) };
}
function Ht(t) {
  return (e, n) => Et(e, Gt(t, n));
}
function Z(t, e) {
  return Et(t, Gt("default", e));
}
Z.loading = (t, e) => Et(t, Gt("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...e }));
function Xo(t, { pending: e, error: n, success: r }, o) {
  let s;
  e && (s = qe(e) ? Z.loading(e, o) : Z.loading(e.render, { ...o, ...e }));
  let i = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, a = (f, u, g) => {
    if (u == null) {
      Z.dismiss(s);
      return;
    }
    let T = { type: f, ...i, ...o, data: g }, R = qe(u) ? { render: u } : u;
    return s ? Z.update(s, { ...T, ...R }) : Z(R.render, { ...T, ...R }), g;
  }, l = Pe(t) ? t() : t;
  return l.then((f) => a("success", r, f)).catch((f) => a("error", n, f)), l;
}
Z.promise = Xo;
Z.success = Ht("success");
Z.info = Ht("info");
Z.error = Ht("error");
Z.warning = Ht("warning");
Z.warn = Z.warning;
Z.dark = (t, e) => Et(t, Gt("default", { theme: "dark", ...e }));
function Qo(t) {
  jo(t);
}
Z.dismiss = Qo;
Z.clearWaitingQueue = qo;
Z.isActive = Ur;
Z.update = (t, e = {}) => {
  let n = Fo(t, e);
  if (n) {
    let { props: r, content: o } = n, s = { delay: 100, ...r, ...e, toastId: e.toastId || t, updateId: Wr() };
    s.toastId !== t && (s.staleId = t);
    let i = s.render || o;
    delete s.render, Et(i, s);
  }
};
Z.done = (t) => {
  Z.update(t, { progress: 1 });
};
Z.onChange = Ko;
Z.play = (t) => Gr(!0, t);
Z.pause = (t) => Gr(!1, t);
function $o(t) {
  var e;
  let { subscribe: n, getSnapshot: r, setProps: o } = Le(Zo(t)).current;
  o(t);
  let s = (e = wo(n, r, r)) == null ? void 0 : e.slice();
  function i(a) {
    if (!s) return [];
    let l = /* @__PURE__ */ new Map();
    return t.newestOnTop && s.reverse(), s.forEach((f) => {
      let { position: u } = f.props;
      l.has(u) || l.set(u, []), l.get(u).push(f);
    }), Array.from(l, (f) => a(f[0], f[1]));
  }
  return { getToastToRender: i, isToastActive: Ur, count: s == null ? void 0 : s.length };
}
function es(t) {
  let [e, n] = zt(!1), [r, o] = zt(!1), s = Le(null), i = Le({ start: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, didMove: !1 }).current, { autoClose: a, pauseOnHover: l, closeToast: f, onClick: u, closeOnClick: g } = t;
  Yo({ id: t.toastId, containerId: t.containerId, fn: n }), ze(() => {
    if (t.pauseOnFocusLoss) return T(), () => {
      R();
    };
  }, [t.pauseOnFocusLoss]);
  function T() {
    document.hasFocus() || x(), window.addEventListener("focus", v), window.addEventListener("blur", x);
  }
  function R() {
    window.removeEventListener("focus", v), window.removeEventListener("blur", x);
  }
  function P(B) {
    if (t.draggable === !0 || t.draggable === B.pointerType) {
      p();
      let H = s.current;
      i.canCloseOnClick = !0, i.canDrag = !0, H.style.transition = "none", t.draggableDirection === "x" ? (i.start = B.clientX, i.removalDistance = H.offsetWidth * (t.draggablePercent / 100)) : (i.start = B.clientY, i.removalDistance = H.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
    }
  }
  function O(B) {
    let { top: H, bottom: ne, left: pe, right: j } = s.current.getBoundingClientRect();
    B.nativeEvent.type !== "touchend" && t.pauseOnHover && B.clientX >= pe && B.clientX <= j && B.clientY >= H && B.clientY <= ne ? x() : v();
  }
  function v() {
    n(!0);
  }
  function x() {
    n(!1);
  }
  function p() {
    i.didMove = !1, document.addEventListener("pointermove", E), document.addEventListener("pointerup", d);
  }
  function y() {
    document.removeEventListener("pointermove", E), document.removeEventListener("pointerup", d);
  }
  function E(B) {
    let H = s.current;
    if (i.canDrag && H) {
      i.didMove = !0, e && x(), t.draggableDirection === "x" ? i.delta = B.clientX - i.start : i.delta = B.clientY - i.start, i.start !== B.clientX && (i.canCloseOnClick = !1);
      let ne = t.draggableDirection === "x" ? `${i.delta}px, var(--y)` : `0, calc(${i.delta}px + var(--y))`;
      H.style.transform = `translate3d(${ne},0)`, H.style.opacity = `${1 - Math.abs(i.delta / i.removalDistance)}`;
    }
  }
  function d() {
    y();
    let B = s.current;
    if (i.canDrag && i.didMove && B) {
      if (i.canDrag = !1, Math.abs(i.delta) > i.removalDistance) {
        o(!0), t.closeToast(!0), t.collapseAll();
        return;
      }
      B.style.transition = "transform 0.2s, opacity 0.2s", B.style.removeProperty("transform"), B.style.removeProperty("opacity");
    }
  }
  let K = { onPointerDown: P, onPointerUp: O };
  return a && l && (K.onMouseEnter = x, t.stacked || (K.onMouseLeave = v)), g && (K.onClick = (B) => {
    u && u(B), i.canCloseOnClick && f(!0);
  }), { playToast: v, pauseToast: x, isRunning: e, preventExitTransition: r, toastRef: s, eventHandlers: K };
}
var ts = typeof window < "u" ? Pr : ze, Ft = ({ theme: t, type: e, isLoading: n, ...r }) => F.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${e})`, ...r });
function ns(t) {
  return F.createElement(Ft, { ...t }, F.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}
function rs(t) {
  return F.createElement(Ft, { ...t }, F.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}
function os(t) {
  return F.createElement(Ft, { ...t }, F.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}
function ss(t) {
  return F.createElement(Ft, { ...t }, F.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}
function is() {
  return F.createElement("div", { className: "Toastify__spinner" });
}
var En = { info: rs, warning: ns, success: os, error: ss, spinner: is }, as = (t) => t in En;
function cs({ theme: t, type: e, isLoading: n, icon: r }) {
  let o = null, s = { theme: t, type: e };
  return r === !1 || (Pe(r) ? o = r({ ...s, isLoading: n }) : Vt(r) ? o = In(r, s) : n ? o = En.spinner() : as(e) && (o = En[e](s))), o;
}
var ls = (t) => {
  let { isRunning: e, preventExitTransition: n, toastRef: r, eventHandlers: o, playToast: s } = es(t), { closeButton: i, children: a, autoClose: l, onClick: f, type: u, hideProgressBar: g, closeToast: T, transition: R, position: P, className: O, style: v, progressClassName: x, updateId: p, role: y, progress: E, rtl: d, toastId: K, deleteToast: B, isIn: H, isLoading: ne, closeOnClick: pe, theme: j, ariaLabel: ie } = t, ye = je("Toastify__toast", `Toastify__toast-theme--${j}`, `Toastify__toast--${u}`, { "Toastify__toast--rtl": d }, { "Toastify__toast--close-on-click": pe }), Ae = Pe(O) ? O({ rtl: d, position: P, type: u, defaultClassName: ye }) : je(ye, O), De = cs(t), ae = !!E || !l, ge = { closeToast: T, type: u, theme: j }, Ee = null;
  return i === !1 || (Pe(i) ? Ee = i(ge) : Vt(i) ? Ee = In(i, ge) : Ee = Wo(ge)), F.createElement(R, { isIn: H, done: B, position: P, preventExitTransition: n, nodeRef: r, playToast: s }, F.createElement("div", { id: K, tabIndex: 0, onClick: f, "data-in": H, className: Ae, ...o, style: v, ref: r, ...H && { role: y, "aria-label": ie } }, De != null && F.createElement("div", { className: je("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !ne }) }, De), Br(a, t, !e), Ee, !t.customProgressBar && F.createElement(zo, { ...p && !ae ? { key: `p-${p}` } : {}, rtl: d, theme: j, delay: l, isRunning: e, isIn: H, closeToast: T, hide: g, type: u, className: x, controlledProgress: ae, progress: E || 0 })));
}, fs = (t, e = !1) => ({ enter: `Toastify--animate Toastify__${t}-enter`, exit: `Toastify--animate Toastify__${t}-exit`, appendPosition: e }), us = Bo(fs("bounce", !0)), ds = { position: "top-right", transition: us, autoClose: 5e3, closeButton: !0, pauseOnHover: !0, pauseOnFocusLoss: !0, draggable: "touch", draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light", "aria-label": "Notifications Alt+T", hotKeys: (t) => t.altKey && t.code === "KeyT" };
function ps(t) {
  let e = { ...ds, ...t }, n = t.stacked, [r, o] = zt(!0), s = Le(null), { getToastToRender: i, isToastActive: a, count: l } = $o(e), { className: f, style: u, rtl: g, containerId: T, hotKeys: R } = e;
  function P(v) {
    let x = je("Toastify__toast-container", `Toastify__toast-container--${v}`, { "Toastify__toast-container--rtl": g });
    return Pe(f) ? f({ position: v, rtl: g, defaultClassName: x }) : je(x, gn(f));
  }
  function O() {
    n && (o(!0), Z.play());
  }
  return ts(() => {
    var v;
    if (n) {
      let x = s.current.querySelectorAll('[data-in="true"]'), p = 12, y = (v = e.position) == null ? void 0 : v.includes("top"), E = 0, d = 0;
      Array.from(x).reverse().forEach((K, B) => {
        let H = K;
        H.classList.add("Toastify__toast--stacked"), B > 0 && (H.dataset.collapsed = `${r}`), H.dataset.pos || (H.dataset.pos = y ? "top" : "bot");
        let ne = E * (r ? 0.2 : 1) + (r ? 0 : p * B);
        H.style.setProperty("--y", `${y ? ne : ne * -1}px`), H.style.setProperty("--g", `${p}`), H.style.setProperty("--s", `${1 - (r ? d : 0)}`), E += H.offsetHeight, d += 0.025;
      });
    }
  }, [r, l, n]), ze(() => {
    function v(x) {
      var p;
      let y = s.current;
      R(x) && ((p = y.querySelector('[tabIndex="0"]')) == null || p.focus(), o(!1), Z.pause()), x.key === "Escape" && (document.activeElement === y || y != null && y.contains(document.activeElement)) && (o(!0), Z.play());
    }
    return document.addEventListener("keydown", v), () => {
      document.removeEventListener("keydown", v);
    };
  }, [R]), F.createElement("section", { ref: s, className: "Toastify", id: T, onMouseEnter: () => {
    n && (o(!1), Z.pause());
  }, onMouseLeave: O, "aria-live": "polite", "aria-atomic": "false", "aria-relevant": "additions text", "aria-label": e["aria-label"] }, i((v, x) => {
    let p = x.length ? { ...u } : { ...u, pointerEvents: "none" };
    return F.createElement("div", { tabIndex: -1, className: P(v), "data-stacked": n, style: p, key: `c-${v}` }, x.map(({ content: y, props: E }) => F.createElement(ls, { ...E, stacked: n, collapseAll: O, isIn: a(E.toastId, E.containerId), key: `t-${E.key}` }, y)));
  }));
}
function Ut() {
  return Ut = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Ut.apply(null, arguments);
}
function Hr(t, e) {
  if (t == null) return {};
  var n = {};
  for (var r in t) if ({}.hasOwnProperty.call(t, r)) {
    if (e.includes(r)) continue;
    n[r] = t[r];
  }
  return n;
}
function vn(t, e) {
  return vn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, vn(t, e);
}
function Fr(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, vn(t, e);
}
function hs(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var bn = { exports: {} }, Rt = { exports: {} }, q = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sr;
function ms() {
  if (sr) return q;
  sr = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, s = t ? Symbol.for("react.profiler") : 60114, i = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, f = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, g = t ? Symbol.for("react.suspense") : 60113, T = t ? Symbol.for("react.suspense_list") : 60120, R = t ? Symbol.for("react.memo") : 60115, P = t ? Symbol.for("react.lazy") : 60116, O = t ? Symbol.for("react.block") : 60121, v = t ? Symbol.for("react.fundamental") : 60117, x = t ? Symbol.for("react.responder") : 60118, p = t ? Symbol.for("react.scope") : 60119;
  function y(d) {
    if (typeof d == "object" && d !== null) {
      var K = d.$$typeof;
      switch (K) {
        case e:
          switch (d = d.type, d) {
            case l:
            case f:
            case r:
            case s:
            case o:
            case g:
              return d;
            default:
              switch (d = d && d.$$typeof, d) {
                case a:
                case u:
                case P:
                case R:
                case i:
                  return d;
                default:
                  return K;
              }
          }
        case n:
          return K;
      }
    }
  }
  function E(d) {
    return y(d) === f;
  }
  return q.AsyncMode = l, q.ConcurrentMode = f, q.ContextConsumer = a, q.ContextProvider = i, q.Element = e, q.ForwardRef = u, q.Fragment = r, q.Lazy = P, q.Memo = R, q.Portal = n, q.Profiler = s, q.StrictMode = o, q.Suspense = g, q.isAsyncMode = function(d) {
    return E(d) || y(d) === l;
  }, q.isConcurrentMode = E, q.isContextConsumer = function(d) {
    return y(d) === a;
  }, q.isContextProvider = function(d) {
    return y(d) === i;
  }, q.isElement = function(d) {
    return typeof d == "object" && d !== null && d.$$typeof === e;
  }, q.isForwardRef = function(d) {
    return y(d) === u;
  }, q.isFragment = function(d) {
    return y(d) === r;
  }, q.isLazy = function(d) {
    return y(d) === P;
  }, q.isMemo = function(d) {
    return y(d) === R;
  }, q.isPortal = function(d) {
    return y(d) === n;
  }, q.isProfiler = function(d) {
    return y(d) === s;
  }, q.isStrictMode = function(d) {
    return y(d) === o;
  }, q.isSuspense = function(d) {
    return y(d) === g;
  }, q.isValidElementType = function(d) {
    return typeof d == "string" || typeof d == "function" || d === r || d === f || d === s || d === o || d === g || d === T || typeof d == "object" && d !== null && (d.$$typeof === P || d.$$typeof === R || d.$$typeof === i || d.$$typeof === a || d.$$typeof === u || d.$$typeof === v || d.$$typeof === x || d.$$typeof === p || d.$$typeof === O);
  }, q.typeOf = y, q;
}
var Y = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ir;
function gs() {
  return ir || (ir = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, s = t ? Symbol.for("react.profiler") : 60114, i = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, f = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, g = t ? Symbol.for("react.suspense") : 60113, T = t ? Symbol.for("react.suspense_list") : 60120, R = t ? Symbol.for("react.memo") : 60115, P = t ? Symbol.for("react.lazy") : 60116, O = t ? Symbol.for("react.block") : 60121, v = t ? Symbol.for("react.fundamental") : 60117, x = t ? Symbol.for("react.responder") : 60118, p = t ? Symbol.for("react.scope") : 60119;
    function y(b) {
      return typeof b == "string" || typeof b == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      b === r || b === f || b === s || b === o || b === g || b === T || typeof b == "object" && b !== null && (b.$$typeof === P || b.$$typeof === R || b.$$typeof === i || b.$$typeof === a || b.$$typeof === u || b.$$typeof === v || b.$$typeof === x || b.$$typeof === p || b.$$typeof === O);
    }
    function E(b) {
      if (typeof b == "object" && b !== null) {
        var he = b.$$typeof;
        switch (he) {
          case e:
            var ve = b.type;
            switch (ve) {
              case l:
              case f:
              case r:
              case s:
              case o:
              case g:
                return ve;
              default:
                var Ye = ve && ve.$$typeof;
                switch (Ye) {
                  case a:
                  case u:
                  case P:
                  case R:
                  case i:
                    return Ye;
                  default:
                    return he;
                }
            }
          case n:
            return he;
        }
      }
    }
    var d = l, K = f, B = a, H = i, ne = e, pe = u, j = r, ie = P, ye = R, Ae = n, De = s, ae = o, ge = g, Ee = !1;
    function ot(b) {
      return Ee || (Ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), h(b) || E(b) === l;
    }
    function h(b) {
      return E(b) === f;
    }
    function A(b) {
      return E(b) === a;
    }
    function L(b) {
      return E(b) === i;
    }
    function C(b) {
      return typeof b == "object" && b !== null && b.$$typeof === e;
    }
    function I(b) {
      return E(b) === u;
    }
    function w(b) {
      return E(b) === r;
    }
    function N(b) {
      return E(b) === P;
    }
    function M(b) {
      return E(b) === R;
    }
    function z(b) {
      return E(b) === n;
    }
    function G(b) {
      return E(b) === s;
    }
    function U(b) {
      return E(b) === o;
    }
    function re(b) {
      return E(b) === g;
    }
    Y.AsyncMode = d, Y.ConcurrentMode = K, Y.ContextConsumer = B, Y.ContextProvider = H, Y.Element = ne, Y.ForwardRef = pe, Y.Fragment = j, Y.Lazy = ie, Y.Memo = ye, Y.Portal = Ae, Y.Profiler = De, Y.StrictMode = ae, Y.Suspense = ge, Y.isAsyncMode = ot, Y.isConcurrentMode = h, Y.isContextConsumer = A, Y.isContextProvider = L, Y.isElement = C, Y.isForwardRef = I, Y.isFragment = w, Y.isLazy = N, Y.isMemo = M, Y.isPortal = z, Y.isProfiler = G, Y.isStrictMode = U, Y.isSuspense = re, Y.isValidElementType = y, Y.typeOf = E;
  }()), Y;
}
var ar;
function jr() {
  return ar || (ar = 1, process.env.NODE_ENV === "production" ? Rt.exports = ms() : Rt.exports = gs()), Rt.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var en, cr;
function ys() {
  if (cr) return en;
  cr = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var i = {}, a = 0; a < 10; a++)
        i["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(i).map(function(u) {
        return i[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        f[u] = u;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return en = o() ? Object.assign : function(s, i) {
    for (var a, l = r(s), f, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var g in a)
        e.call(a, g) && (l[g] = a[g]);
      if (t) {
        f = t(a);
        for (var T = 0; T < f.length; T++)
          n.call(a, f[T]) && (l[f[T]] = a[f[T]]);
      }
    }
    return l;
  }, en;
}
var tn, lr;
function Nn() {
  if (lr) return tn;
  lr = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return tn = t, tn;
}
var nn, fr;
function qr() {
  return fr || (fr = 1, nn = Function.call.bind(Object.prototype.hasOwnProperty)), nn;
}
var rn, ur;
function As() {
  if (ur) return rn;
  ur = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = Nn(), n = {}, r = qr();
    t = function(s) {
      var i = "Warning: " + s;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(s, i, a, l, f) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in s)
        if (r(s, u)) {
          var g;
          try {
            if (typeof s[u] != "function") {
              var T = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw T.name = "Invariant Violation", T;
            }
            g = s[u](i, u, l, a, null, e);
          } catch (P) {
            g = P;
          }
          if (g && !(g instanceof Error) && t(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof g + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), g instanceof Error && !(g.message in n)) {
            n[g.message] = !0;
            var R = f ? f() : "";
            t(
              "Failed " + a + " type: " + g.message + (R ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, rn = o, rn;
}
var on, dr;
function Es() {
  if (dr) return on;
  dr = 1;
  var t = jr(), e = ys(), n = Nn(), r = qr(), o = As(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return on = function(a, l) {
    var f = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function g(h) {
      var A = h && (f && h[f] || h[u]);
      if (typeof A == "function")
        return A;
    }
    var T = "<<anonymous>>", R = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: p(),
      arrayOf: y,
      element: E(),
      elementType: d(),
      instanceOf: K,
      node: pe(),
      objectOf: H,
      oneOf: B,
      oneOfType: ne,
      shape: ie,
      exact: ye
    };
    function P(h, A) {
      return h === A ? h !== 0 || 1 / h === 1 / A : h !== h && A !== A;
    }
    function O(h, A) {
      this.message = h, this.data = A && typeof A == "object" ? A : {}, this.stack = "";
    }
    O.prototype = Error.prototype;
    function v(h) {
      if (process.env.NODE_ENV !== "production")
        var A = {}, L = 0;
      function C(w, N, M, z, G, U, re) {
        if (z = z || T, U = U || M, re !== n) {
          if (l) {
            var b = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw b.name = "Invariant Violation", b;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var he = z + ":" + M;
            !A[he] && // Avoid spamming the console because they are often not actionable except for lib authors
            L < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + U + "` prop on `" + z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), A[he] = !0, L++);
          }
        }
        return N[M] == null ? w ? N[M] === null ? new O("The " + G + " `" + U + "` is marked as required " + ("in `" + z + "`, but its value is `null`.")) : new O("The " + G + " `" + U + "` is marked as required in " + ("`" + z + "`, but its value is `undefined`.")) : null : h(N, M, z, G, U);
      }
      var I = C.bind(null, !1);
      return I.isRequired = C.bind(null, !0), I;
    }
    function x(h) {
      function A(L, C, I, w, N, M) {
        var z = L[C], G = ae(z);
        if (G !== h) {
          var U = ge(z);
          return new O(
            "Invalid " + w + " `" + N + "` of type " + ("`" + U + "` supplied to `" + I + "`, expected ") + ("`" + h + "`."),
            { expectedType: h }
          );
        }
        return null;
      }
      return v(A);
    }
    function p() {
      return v(i);
    }
    function y(h) {
      function A(L, C, I, w, N) {
        if (typeof h != "function")
          return new O("Property `" + N + "` of component `" + I + "` has invalid PropType notation inside arrayOf.");
        var M = L[C];
        if (!Array.isArray(M)) {
          var z = ae(M);
          return new O("Invalid " + w + " `" + N + "` of type " + ("`" + z + "` supplied to `" + I + "`, expected an array."));
        }
        for (var G = 0; G < M.length; G++) {
          var U = h(M, G, I, w, N + "[" + G + "]", n);
          if (U instanceof Error)
            return U;
        }
        return null;
      }
      return v(A);
    }
    function E() {
      function h(A, L, C, I, w) {
        var N = A[L];
        if (!a(N)) {
          var M = ae(N);
          return new O("Invalid " + I + " `" + w + "` of type " + ("`" + M + "` supplied to `" + C + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(h);
    }
    function d() {
      function h(A, L, C, I, w) {
        var N = A[L];
        if (!t.isValidElementType(N)) {
          var M = ae(N);
          return new O("Invalid " + I + " `" + w + "` of type " + ("`" + M + "` supplied to `" + C + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(h);
    }
    function K(h) {
      function A(L, C, I, w, N) {
        if (!(L[C] instanceof h)) {
          var M = h.name || T, z = ot(L[C]);
          return new O("Invalid " + w + " `" + N + "` of type " + ("`" + z + "` supplied to `" + I + "`, expected ") + ("instance of `" + M + "`."));
        }
        return null;
      }
      return v(A);
    }
    function B(h) {
      if (!Array.isArray(h))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), i;
      function A(L, C, I, w, N) {
        for (var M = L[C], z = 0; z < h.length; z++)
          if (P(M, h[z]))
            return null;
        var G = JSON.stringify(h, function(re, b) {
          var he = ge(b);
          return he === "symbol" ? String(b) : b;
        });
        return new O("Invalid " + w + " `" + N + "` of value `" + String(M) + "` " + ("supplied to `" + I + "`, expected one of " + G + "."));
      }
      return v(A);
    }
    function H(h) {
      function A(L, C, I, w, N) {
        if (typeof h != "function")
          return new O("Property `" + N + "` of component `" + I + "` has invalid PropType notation inside objectOf.");
        var M = L[C], z = ae(M);
        if (z !== "object")
          return new O("Invalid " + w + " `" + N + "` of type " + ("`" + z + "` supplied to `" + I + "`, expected an object."));
        for (var G in M)
          if (r(M, G)) {
            var U = h(M, G, I, w, N + "." + G, n);
            if (U instanceof Error)
              return U;
          }
        return null;
      }
      return v(A);
    }
    function ne(h) {
      if (!Array.isArray(h))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var A = 0; A < h.length; A++) {
        var L = h[A];
        if (typeof L != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Ee(L) + " at index " + A + "."
          ), i;
      }
      function C(I, w, N, M, z) {
        for (var G = [], U = 0; U < h.length; U++) {
          var re = h[U], b = re(I, w, N, M, z, n);
          if (b == null)
            return null;
          b.data && r(b.data, "expectedType") && G.push(b.data.expectedType);
        }
        var he = G.length > 0 ? ", expected one of type [" + G.join(", ") + "]" : "";
        return new O("Invalid " + M + " `" + z + "` supplied to " + ("`" + N + "`" + he + "."));
      }
      return v(C);
    }
    function pe() {
      function h(A, L, C, I, w) {
        return Ae(A[L]) ? null : new O("Invalid " + I + " `" + w + "` supplied to " + ("`" + C + "`, expected a ReactNode."));
      }
      return v(h);
    }
    function j(h, A, L, C, I) {
      return new O(
        (h || "React class") + ": " + A + " type `" + L + "." + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + I + "`."
      );
    }
    function ie(h) {
      function A(L, C, I, w, N) {
        var M = L[C], z = ae(M);
        if (z !== "object")
          return new O("Invalid " + w + " `" + N + "` of type `" + z + "` " + ("supplied to `" + I + "`, expected `object`."));
        for (var G in h) {
          var U = h[G];
          if (typeof U != "function")
            return j(I, w, N, G, ge(U));
          var re = U(M, G, I, w, N + "." + G, n);
          if (re)
            return re;
        }
        return null;
      }
      return v(A);
    }
    function ye(h) {
      function A(L, C, I, w, N) {
        var M = L[C], z = ae(M);
        if (z !== "object")
          return new O("Invalid " + w + " `" + N + "` of type `" + z + "` " + ("supplied to `" + I + "`, expected `object`."));
        var G = e({}, L[C], h);
        for (var U in G) {
          var re = h[U];
          if (r(h, U) && typeof re != "function")
            return j(I, w, N, U, ge(re));
          if (!re)
            return new O(
              "Invalid " + w + " `" + N + "` key `" + U + "` supplied to `" + I + "`.\nBad object: " + JSON.stringify(L[C], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(h), null, "  ")
            );
          var b = re(M, U, I, w, N + "." + U, n);
          if (b)
            return b;
        }
        return null;
      }
      return v(A);
    }
    function Ae(h) {
      switch (typeof h) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !h;
        case "object":
          if (Array.isArray(h))
            return h.every(Ae);
          if (h === null || a(h))
            return !0;
          var A = g(h);
          if (A) {
            var L = A.call(h), C;
            if (A !== h.entries) {
              for (; !(C = L.next()).done; )
                if (!Ae(C.value))
                  return !1;
            } else
              for (; !(C = L.next()).done; ) {
                var I = C.value;
                if (I && !Ae(I[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function De(h, A) {
      return h === "symbol" ? !0 : A ? A["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && A instanceof Symbol : !1;
    }
    function ae(h) {
      var A = typeof h;
      return Array.isArray(h) ? "array" : h instanceof RegExp ? "object" : De(A, h) ? "symbol" : A;
    }
    function ge(h) {
      if (typeof h > "u" || h === null)
        return "" + h;
      var A = ae(h);
      if (A === "object") {
        if (h instanceof Date)
          return "date";
        if (h instanceof RegExp)
          return "regexp";
      }
      return A;
    }
    function Ee(h) {
      var A = ge(h);
      switch (A) {
        case "array":
        case "object":
          return "an " + A;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + A;
        default:
          return A;
      }
    }
    function ot(h) {
      return !h.constructor || !h.constructor.name ? T : h.constructor.name;
    }
    return R.checkPropTypes = o, R.resetWarningCache = o.resetWarningCache, R.PropTypes = R, R;
  }, on;
}
var sn, pr;
function vs() {
  if (pr) return sn;
  pr = 1;
  var t = Nn();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, sn = function() {
    function r(i, a, l, f, u, g) {
      if (g !== t) {
        var T = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw T.name = "Invariant Violation", T;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return s.PropTypes = s, s;
  }, sn;
}
if (process.env.NODE_ENV !== "production") {
  var bs = jr(), Ts = !0;
  bn.exports = Es()(bs.isElement, Ts);
} else
  bn.exports = vs()();
var _s = bn.exports;
const k = /* @__PURE__ */ hs(_s);
function xs(t, e) {
  return t.classList ? !!e && t.classList.contains(e) : (" " + (t.className.baseVal || t.className) + " ").indexOf(" " + e + " ") !== -1;
}
function Ss(t, e) {
  t.classList ? t.classList.add(e) : xs(t, e) || (typeof t.className == "string" ? t.className = t.className + " " + e : t.setAttribute("class", (t.className && t.className.baseVal || "") + " " + e));
}
function hr(t, e) {
  return t.replace(new RegExp("(^|\\s)" + e + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function Cs(t, e) {
  t.classList ? t.classList.remove(e) : typeof t.className == "string" ? t.className = hr(t.className, e) : t.setAttribute("class", hr(t.className && t.className.baseVal || "", e));
}
const mr = {
  disabled: !1
};
var ws = process.env.NODE_ENV !== "production" ? k.oneOfType([k.number, k.shape({
  enter: k.number,
  exit: k.number,
  appear: k.number
}).isRequired]) : null, Os = process.env.NODE_ENV !== "production" ? k.oneOfType([k.string, k.shape({
  enter: k.string,
  exit: k.string,
  active: k.string
}), k.shape({
  enter: k.string,
  enterDone: k.string,
  enterActive: k.string,
  exit: k.string,
  exitDone: k.string,
  exitActive: k.string
})]) : null;
const Yr = F.createContext(null);
var Zr = function(e) {
  return e.scrollTop;
}, mt = "unmounted", Ve = "exited", Ge = "entering", et = "entered", Tn = "exiting", Ie = /* @__PURE__ */ function(t) {
  Fr(e, t);
  function e(r, o) {
    var s;
    s = t.call(this, r, o) || this;
    var i = o, a = i && !i.isMounting ? r.enter : r.appear, l;
    return s.appearStatus = null, r.in ? a ? (l = Ve, s.appearStatus = Ge) : l = et : r.unmountOnExit || r.mountOnEnter ? l = mt : l = Ve, s.state = {
      status: l
    }, s.nextCallback = null, s;
  }
  e.getDerivedStateFromProps = function(o, s) {
    var i = o.in;
    return i && s.status === mt ? {
      status: Ve
    } : null;
  };
  var n = e.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(o) {
    var s = null;
    if (o !== this.props) {
      var i = this.state.status;
      this.props.in ? i !== Ge && i !== et && (s = Ge) : (i === Ge || i === et) && (s = Tn);
    }
    this.updateStatus(!1, s);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var o = this.props.timeout, s, i, a;
    return s = i = a = o, o != null && typeof o != "number" && (s = o.exit, i = o.enter, a = o.appear !== void 0 ? o.appear : i), {
      exit: s,
      enter: i,
      appear: a
    };
  }, n.updateStatus = function(o, s) {
    if (o === void 0 && (o = !1), s !== null)
      if (this.cancelNextCallback(), s === Ge) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var i = this.props.nodeRef ? this.props.nodeRef.current : Ot.findDOMNode(this);
          i && Zr(i);
        }
        this.performEnter(o);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === Ve && this.setState({
      status: mt
    });
  }, n.performEnter = function(o) {
    var s = this, i = this.props.enter, a = this.context ? this.context.isMounting : o, l = this.props.nodeRef ? [a] : [Ot.findDOMNode(this), a], f = l[0], u = l[1], g = this.getTimeouts(), T = a ? g.appear : g.enter;
    if (!o && !i || mr.disabled) {
      this.safeSetState({
        status: et
      }, function() {
        s.props.onEntered(f);
      });
      return;
    }
    this.props.onEnter(f, u), this.safeSetState({
      status: Ge
    }, function() {
      s.props.onEntering(f, u), s.onTransitionEnd(T, function() {
        s.safeSetState({
          status: et
        }, function() {
          s.props.onEntered(f, u);
        });
      });
    });
  }, n.performExit = function() {
    var o = this, s = this.props.exit, i = this.getTimeouts(), a = this.props.nodeRef ? void 0 : Ot.findDOMNode(this);
    if (!s || mr.disabled) {
      this.safeSetState({
        status: Ve
      }, function() {
        o.props.onExited(a);
      });
      return;
    }
    this.props.onExit(a), this.safeSetState({
      status: Tn
    }, function() {
      o.props.onExiting(a), o.onTransitionEnd(i.exit, function() {
        o.safeSetState({
          status: Ve
        }, function() {
          o.props.onExited(a);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(o, s) {
    s = this.setNextCallback(s), this.setState(o, s);
  }, n.setNextCallback = function(o) {
    var s = this, i = !0;
    return this.nextCallback = function(a) {
      i && (i = !1, s.nextCallback = null, o(a));
    }, this.nextCallback.cancel = function() {
      i = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(o, s) {
    this.setNextCallback(s);
    var i = this.props.nodeRef ? this.props.nodeRef.current : Ot.findDOMNode(this), a = o == null && !this.props.addEndListener;
    if (!i || a) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var l = this.props.nodeRef ? [this.nextCallback] : [i, this.nextCallback], f = l[0], u = l[1];
      this.props.addEndListener(f, u);
    }
    o != null && setTimeout(this.nextCallback, o);
  }, n.render = function() {
    var o = this.state.status;
    if (o === mt)
      return null;
    var s = this.props, i = s.children;
    s.in, s.mountOnEnter, s.unmountOnExit, s.appear, s.enter, s.exit, s.timeout, s.addEndListener, s.onEnter, s.onEntering, s.onEntered, s.onExit, s.onExiting, s.onExited, s.nodeRef;
    var a = Hr(s, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ F.createElement(Yr.Provider, {
        value: null
      }, typeof i == "function" ? i(o, a) : F.cloneElement(F.Children.only(i), a))
    );
  }, e;
}(F.Component);
Ie.contextType = Yr;
Ie.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: k.shape({
    current: typeof Element > "u" ? k.any : function(t, e, n, r, o, s) {
      var i = t[e];
      return k.instanceOf(i && "ownerDocument" in i ? i.ownerDocument.defaultView.Element : Element)(t, e, n, r, o, s);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: k.oneOfType([k.func.isRequired, k.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: k.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: k.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: k.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: k.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: k.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: k.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(e) {
    var n = ws;
    e.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
      o[s - 1] = arguments[s];
    return n.apply(void 0, [e].concat(o));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: k.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: k.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: k.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: k.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: k.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: k.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: k.func
} : {};
function $e() {
}
Ie.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: $e,
  onEntering: $e,
  onEntered: $e,
  onExit: $e,
  onExiting: $e,
  onExited: $e
};
Ie.UNMOUNTED = mt;
Ie.EXITED = Ve;
Ie.ENTERING = Ge;
Ie.ENTERED = et;
Ie.EXITING = Tn;
var Rs = function(e, n) {
  return e && n && n.split(" ").forEach(function(r) {
    return Ss(e, r);
  });
}, an = function(e, n) {
  return e && n && n.split(" ").forEach(function(r) {
    return Cs(e, r);
  });
}, Mn = /* @__PURE__ */ function(t) {
  Fr(e, t);
  function e() {
    for (var r, o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)) || this, r.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, r.onEnter = function(a, l) {
      var f = r.resolveArguments(a, l), u = f[0], g = f[1];
      r.removeClasses(u, "exit"), r.addClass(u, g ? "appear" : "enter", "base"), r.props.onEnter && r.props.onEnter(a, l);
    }, r.onEntering = function(a, l) {
      var f = r.resolveArguments(a, l), u = f[0], g = f[1], T = g ? "appear" : "enter";
      r.addClass(u, T, "active"), r.props.onEntering && r.props.onEntering(a, l);
    }, r.onEntered = function(a, l) {
      var f = r.resolveArguments(a, l), u = f[0], g = f[1], T = g ? "appear" : "enter";
      r.removeClasses(u, T), r.addClass(u, T, "done"), r.props.onEntered && r.props.onEntered(a, l);
    }, r.onExit = function(a) {
      var l = r.resolveArguments(a), f = l[0];
      r.removeClasses(f, "appear"), r.removeClasses(f, "enter"), r.addClass(f, "exit", "base"), r.props.onExit && r.props.onExit(a);
    }, r.onExiting = function(a) {
      var l = r.resolveArguments(a), f = l[0];
      r.addClass(f, "exit", "active"), r.props.onExiting && r.props.onExiting(a);
    }, r.onExited = function(a) {
      var l = r.resolveArguments(a), f = l[0];
      r.removeClasses(f, "exit"), r.addClass(f, "exit", "done"), r.props.onExited && r.props.onExited(a);
    }, r.resolveArguments = function(a, l) {
      return r.props.nodeRef ? [r.props.nodeRef.current, a] : [a, l];
    }, r.getClassNames = function(a) {
      var l = r.props.classNames, f = typeof l == "string", u = f && l ? l + "-" : "", g = f ? "" + u + a : l[a], T = f ? g + "-active" : l[a + "Active"], R = f ? g + "-done" : l[a + "Done"];
      return {
        baseClassName: g,
        activeClassName: T,
        doneClassName: R
      };
    }, r;
  }
  var n = e.prototype;
  return n.addClass = function(o, s, i) {
    var a = this.getClassNames(s)[i + "ClassName"], l = this.getClassNames("enter"), f = l.doneClassName;
    s === "appear" && i === "done" && f && (a += " " + f), i === "active" && o && Zr(o), a && (this.appliedClasses[s][i] = a, Rs(o, a));
  }, n.removeClasses = function(o, s) {
    var i = this.appliedClasses[s], a = i.base, l = i.active, f = i.done;
    this.appliedClasses[s] = {}, a && an(o, a), l && an(o, l), f && an(o, f);
  }, n.render = function() {
    var o = this.props;
    o.classNames;
    var s = Hr(o, ["classNames"]);
    return /* @__PURE__ */ F.createElement(Ie, Ut({}, s, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, e;
}(F.Component);
Mn.defaultProps = {
  classNames: ""
};
Mn.propTypes = process.env.NODE_ENV !== "production" ? Ut({}, Ie.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: Os,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: k.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: k.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: k.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: k.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: k.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: k.func
}) : {};
const Kr = Oo(void 0), nt = () => {
  const t = Ro(Kr);
  if (t === void 0)
    throw new Error("useChatContext must be used within a ChatProvider");
  return t;
}, ks = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20style='enable-background:new%200%200%2057.3%2068.9'%20xml:space='preserve'%20viewBox='9.2%209.2%2038.8%2050.4'%3e%3cpath%20style='fill:none'%20d='M0%200h57.3v68.9H0z'%20/%3e%3clinearGradient%20id='a'%20gradientUnits='userSpaceOnUse'%20x1='-122.968'%20y1='-26.013'%20x2='-159.967'%20y2='3.413'%20gradientTransform='matrix(1%200%200%20-1%20174.275%206.149)'%3e%3cstop%20offset='.33'%20style='stop-color:%23ff9a1e;stop-opacity:0'%20/%3e%3cstop%20offset='.71'%20style='stop-color:%23ff9a1e'%20/%3e%3c/linearGradient%3e%3cpath%20style='fill:url(%23a)'%20d='M48%209.2H9.2l19.4%2025.2z'%20/%3e%3clinearGradient%20id='b'%20gradientUnits='userSpaceOnUse'%20x1='-161.807'%20y1='-34.313'%20x2='-127.582'%20y2='-69.159'%20gradientTransform='matrix(1%200%200%20-1%20174.275%206.149)'%3e%3cstop%20offset='.07'%20style='stop-color:%23ff37f0'%20/%3e%3cstop%20offset='.755'%20style='stop-color:%23ff37f0;stop-opacity:0'%20/%3e%3c/linearGradient%3e%3cpath%20style='fill:url(%23b)'%20d='M9.2%2059.6H48L28.6%2034.4z'%20/%3e%3clinearGradient%20id='c'%20gradientUnits='userSpaceOnUse'%20x1='-157.867'%20y1='-47.908'%20x2='-194.866'%20y2='-18.481'%20gradientTransform='matrix(1%200%200%20-1%20191.76%206.149)'%3e%3cstop%20offset='.352'%20style='stop-color:%23ff5ae2'%20/%3e%3cstop%20offset='.655'%20style='stop-color:%23ff211c'%20/%3e%3c/linearGradient%3e%3cpath%20style='fill:url(%23c)'%20d='M9.2%209.2v50.4l19.4-25.2z'%20/%3e%3c/svg%3e";
function Is({ logoImage: t, title: e = "Ksyos Chat" }) {
  return /* @__PURE__ */ W(Ns, { children: /* @__PURE__ */ Oe(Ms, { children: [
    /* @__PURE__ */ W(
      Ls,
      {
        alt: e,
        src: t ?? ks
      }
    ),
    /* @__PURE__ */ W(Ps, { children: e })
  ] }) });
}
const Ns = te.header`
    width: 100%;
    flex-shrink: 0; /* Prevent header from shrinking */
    height: 52px;
    padding: 0px 0px 16px 0px;
    gap: 10px;
    border-bottom: 1px solid rgba(224, 224, 224, 1);
    color: #333;
`, Ms = te.div`
    display: flex;
    align-items: center;
`, Ls = te.img`
    height: 40px;
    width: 40px;
`, Ps = te.h4`
    padding-left: 10px;
    font-size: 18px;
`, Ds = "data:image/svg+xml,%3csvg%20id='ksyc-chatbot-send-button'%20xmlns='http://www.w3.org/2000/svg'%20width='31'%20height='33'%20viewBox='0%200%2031%2033'%20fill='none'%20style='margin-bottom:%208px;'%3e%3cpath%20d='M28.856%2014.6905L28.8463%2014.6862L2.98799%203.61491C2.77049%203.52094%202.53382%203.48409%202.29915%203.50765C2.06448%203.53121%201.83912%203.61444%201.64324%203.74991C1.43629%203.88989%201.2663%204.08079%201.14856%204.30542C1.03082%204.53006%200.969032%204.78138%200.96875%205.03679V12.1174C0.968865%2012.4666%201.08697%2012.8047%201.30272%2013.0737C1.51846%2013.3426%201.81833%2013.5254%202.15063%2013.5905L16.2538%2016.2824C16.3092%2016.2933%2016.3592%2016.3237%2016.3952%2016.3686C16.4312%2016.4134%2016.4509%2016.4698%2016.4509%2016.528C16.4509%2016.5863%2016.4312%2016.6427%2016.3952%2016.6875C16.3592%2016.7323%2016.3092%2016.7628%2016.2538%2016.7737L2.15123%2019.4655C1.81902%2019.5305%201.51918%2019.7131%201.30334%2019.9818C1.0875%2020.2504%200.969174%2020.5884%200.96875%2020.9374V28.0193C0.96859%2028.2632%201.02709%2028.5033%201.139%2028.7181C1.25091%2028.9329%201.41273%2029.1156%201.60994%2029.2499C1.84716%2029.4126%202.12556%2029.4996%202.41037%2029.4999C2.60837%2029.4997%202.80434%2029.4587%202.98678%2029.3793L28.8445%2018.3712L28.856%2018.3655C29.2041%2018.2111%2029.5007%2017.9548%2029.7091%2017.6282C29.9175%2017.3016%2030.0285%2016.9191%2030.0285%2016.528C30.0285%2016.137%2029.9175%2015.7545%2029.7091%2015.4279C29.5007%2015.1013%2029.2041%2014.8449%2028.856%2014.6905Z'%20fill='%235C5C5C'/%3e%3c/svg%3e", J = {
  chatMessage: {
    notReceived: "Bericht nog niet ontvangen",
    received: "Bericht ontvangen"
  },
  chatProvider: {
    chatClosedByAgent: "De chat is gesloten door de medewerker. Sluit de chat om een nieuwe chat te starten.",
    connected: "Je bent verbonden met de chat.",
    disconnected: "Je bent losgekoppeld van de chat."
  },
  errors: {
    chatConnectionError: "Er is een fout opgetreden met de chatverbinding.",
    failedToInitializeChat: "Kan chat niet initialiseren",
    fetchHistoryError: "Fout bij het ophalen van de chatgeschiedenis, probeer het later opnieuw",
    fetchHistoryFailed: "Ophalen van chatgeschiedenis mislukt",
    missingThreadOrToken: "Ontbrekende thread-ID of toegangstoken, kan bericht niet verzenden",
    notificationSoundError: "Fout bij het afspelen van meldingsgeluid:",
    outsideWorkingHoursError: "Buiten kantooruren",
    unableToInitializeChat: "Kan geen verbinding maken. Controleer uw netwerk en probeer het later opnieuw",
    websocketError: "WebSocket-fout:",
    websocketNotConnected: "WebSocket is niet verbonden"
  },
  messageList: {
    newMessages: "Nieuwe berichten",
    noMessages: "Nog geen berichten.",
    outsideWorkingHours: "We zijn momenteel gesloten. Probeer het opnieuw tijdens kantooruren."
  },
  textInput: {
    placeholder: "Schrijf een bericht...",
    sendButton: "Verstuur"
  },
  welcome: {
    buttonText: "Start Chat",
    description: "Chat nu met een medewerker van de Servicedesk om je te helpen met jouw vragen en problemen.",
    listItems: {
      faq: "Krijg snel antwoord op veelgestelde vragen",
      guidance: "Voor begeleiding bij het gebruik van onze diensten",
      support: "Problemen melden en ondersteuning krijgen"
    },
    title: "Welkom bij onze Ksyos chat"
  }
};
/*! @license DOMPurify 3.2.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.4/LICENSE */
const {
  entries: Jr,
  setPrototypeOf: gr,
  isFrozen: Bs,
  getPrototypeOf: Ws,
  getOwnPropertyDescriptor: zs
} = Object;
let {
  freeze: ue,
  seal: Te,
  create: Xr
} = Object, {
  apply: _n,
  construct: xn
} = typeof Reflect < "u" && Reflect;
ue || (ue = function(e) {
  return e;
});
Te || (Te = function(e) {
  return e;
});
_n || (_n = function(e, n, r) {
  return e.apply(n, r);
});
xn || (xn = function(e, n) {
  return new e(...n);
});
const kt = de(Array.prototype.forEach), Us = de(Array.prototype.lastIndexOf), yr = de(Array.prototype.pop), lt = de(Array.prototype.push), Vs = de(Array.prototype.splice), Lt = de(String.prototype.toLowerCase), cn = de(String.prototype.toString), Ar = de(String.prototype.match), ft = de(String.prototype.replace), Gs = de(String.prototype.indexOf), Hs = de(String.prototype.trim), _e = de(Object.prototype.hasOwnProperty), le = de(RegExp.prototype.test), ut = Fs(TypeError);
function de(t) {
  return function(e) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    return _n(t, e, r);
  };
}
function Fs(t) {
  return function() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return xn(t, n);
  };
}
function D(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Lt;
  gr && gr(t, null);
  let r = e.length;
  for (; r--; ) {
    let o = e[r];
    if (typeof o == "string") {
      const s = n(o);
      s !== o && (Bs(e) || (e[r] = s), o = s);
    }
    t[o] = !0;
  }
  return t;
}
function js(t) {
  for (let e = 0; e < t.length; e++)
    _e(t, e) || (t[e] = null);
  return t;
}
function He(t) {
  const e = Xr(null);
  for (const [n, r] of Jr(t))
    _e(t, n) && (Array.isArray(r) ? e[n] = js(r) : r && typeof r == "object" && r.constructor === Object ? e[n] = He(r) : e[n] = r);
  return e;
}
function dt(t, e) {
  for (; t !== null; ) {
    const r = zs(t, e);
    if (r) {
      if (r.get)
        return de(r.get);
      if (typeof r.value == "function")
        return de(r.value);
    }
    t = Ws(t);
  }
  function n() {
    return null;
  }
  return n;
}
const Er = ue(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), ln = ue(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), fn = ue(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), qs = ue(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), un = ue(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Ys = ue(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), vr = ue(["#text"]), br = ue(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), dn = ue(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Tr = ue(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), It = ue(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Zs = Te(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Ks = Te(/<%[\w\W]*|[\w\W]*%>/gm), Js = Te(/\$\{[\w\W]*/gm), Xs = Te(/^data-[\-\w.\u00B7-\uFFFF]+$/), Qs = Te(/^aria-[\-\w]+$/), Qr = Te(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), $s = Te(/^(?:\w+script|data):/i), ei = Te(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), $r = Te(/^html$/i), ti = Te(/^[a-z][.\w]*(-[.\w]+)+$/i);
var _r = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: Qs,
  ATTR_WHITESPACE: ei,
  CUSTOM_ELEMENT: ti,
  DATA_ATTR: Xs,
  DOCTYPE_NAME: $r,
  ERB_EXPR: Ks,
  IS_ALLOWED_URI: Qr,
  IS_SCRIPT_OR_DATA: $s,
  MUSTACHE_EXPR: Zs,
  TMPLIT_EXPR: Js
});
const pt = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, ni = function() {
  return typeof window > "u" ? null : window;
}, ri = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const o = "data-tt-policy-suffix";
  n && n.hasAttribute(o) && (r = n.getAttribute(o));
  const s = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(s, {
      createHTML(i) {
        return i;
      },
      createScriptURL(i) {
        return i;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + s + " could not be created."), null;
  }
}, xr = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function eo() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ni();
  const e = (S) => eo(S);
  if (e.version = "3.2.4", e.removed = [], !t || !t.document || t.document.nodeType !== pt.document || !t.Element)
    return e.isSupported = !1, e;
  let {
    document: n
  } = t;
  const r = n, o = r.currentScript, {
    DocumentFragment: s,
    HTMLTemplateElement: i,
    Node: a,
    Element: l,
    NodeFilter: f,
    NamedNodeMap: u = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: g,
    DOMParser: T,
    trustedTypes: R
  } = t, P = l.prototype, O = dt(P, "cloneNode"), v = dt(P, "remove"), x = dt(P, "nextSibling"), p = dt(P, "childNodes"), y = dt(P, "parentNode");
  if (typeof i == "function") {
    const S = n.createElement("template");
    S.content && S.content.ownerDocument && (n = S.content.ownerDocument);
  }
  let E, d = "";
  const {
    implementation: K,
    createNodeIterator: B,
    createDocumentFragment: H,
    getElementsByTagName: ne
  } = n, {
    importNode: pe
  } = r;
  let j = xr();
  e.isSupported = typeof Jr == "function" && typeof y == "function" && K && K.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: ie,
    ERB_EXPR: ye,
    TMPLIT_EXPR: Ae,
    DATA_ATTR: De,
    ARIA_ATTR: ae,
    IS_SCRIPT_OR_DATA: ge,
    ATTR_WHITESPACE: Ee,
    CUSTOM_ELEMENT: ot
  } = _r;
  let {
    IS_ALLOWED_URI: h
  } = _r, A = null;
  const L = D({}, [...Er, ...ln, ...fn, ...un, ...vr]);
  let C = null;
  const I = D({}, [...br, ...dn, ...Tr, ...It]);
  let w = Object.seal(Xr(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), N = null, M = null, z = !0, G = !0, U = !1, re = !0, b = !1, he = !0, ve = !1, Ye = !1, Yt = !1, Ze = !1, bt = !1, Tt = !1, zn = !0, Un = !1;
  const Eo = "user-content-";
  let Zt = !0, st = !1, Ke = {}, Je = null;
  const Vn = D({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Gn = null;
  const Hn = D({}, ["audio", "video", "img", "source", "image", "track"]);
  let Kt = null;
  const Fn = D({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), _t = "http://www.w3.org/1998/Math/MathML", xt = "http://www.w3.org/2000/svg", Ne = "http://www.w3.org/1999/xhtml";
  let Xe = Ne, Jt = !1, Xt = null;
  const vo = D({}, [_t, xt, Ne], cn);
  let St = D({}, ["mi", "mo", "mn", "ms", "mtext"]), Ct = D({}, ["annotation-xml"]);
  const bo = D({}, ["title", "style", "font", "a", "script"]);
  let it = null;
  const To = ["application/xhtml+xml", "text/html"], _o = "text/html";
  let ee = null, Qe = null;
  const xo = n.createElement("form"), jn = function(c) {
    return c instanceof RegExp || c instanceof Function;
  }, Qt = function() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Qe && Qe === c)) {
      if ((!c || typeof c != "object") && (c = {}), c = He(c), it = // eslint-disable-next-line unicorn/prefer-includes
      To.indexOf(c.PARSER_MEDIA_TYPE) === -1 ? _o : c.PARSER_MEDIA_TYPE, ee = it === "application/xhtml+xml" ? cn : Lt, A = _e(c, "ALLOWED_TAGS") ? D({}, c.ALLOWED_TAGS, ee) : L, C = _e(c, "ALLOWED_ATTR") ? D({}, c.ALLOWED_ATTR, ee) : I, Xt = _e(c, "ALLOWED_NAMESPACES") ? D({}, c.ALLOWED_NAMESPACES, cn) : vo, Kt = _e(c, "ADD_URI_SAFE_ATTR") ? D(He(Fn), c.ADD_URI_SAFE_ATTR, ee) : Fn, Gn = _e(c, "ADD_DATA_URI_TAGS") ? D(He(Hn), c.ADD_DATA_URI_TAGS, ee) : Hn, Je = _e(c, "FORBID_CONTENTS") ? D({}, c.FORBID_CONTENTS, ee) : Vn, N = _e(c, "FORBID_TAGS") ? D({}, c.FORBID_TAGS, ee) : {}, M = _e(c, "FORBID_ATTR") ? D({}, c.FORBID_ATTR, ee) : {}, Ke = _e(c, "USE_PROFILES") ? c.USE_PROFILES : !1, z = c.ALLOW_ARIA_ATTR !== !1, G = c.ALLOW_DATA_ATTR !== !1, U = c.ALLOW_UNKNOWN_PROTOCOLS || !1, re = c.ALLOW_SELF_CLOSE_IN_ATTR !== !1, b = c.SAFE_FOR_TEMPLATES || !1, he = c.SAFE_FOR_XML !== !1, ve = c.WHOLE_DOCUMENT || !1, Ze = c.RETURN_DOM || !1, bt = c.RETURN_DOM_FRAGMENT || !1, Tt = c.RETURN_TRUSTED_TYPE || !1, Yt = c.FORCE_BODY || !1, zn = c.SANITIZE_DOM !== !1, Un = c.SANITIZE_NAMED_PROPS || !1, Zt = c.KEEP_CONTENT !== !1, st = c.IN_PLACE || !1, h = c.ALLOWED_URI_REGEXP || Qr, Xe = c.NAMESPACE || Ne, St = c.MATHML_TEXT_INTEGRATION_POINTS || St, Ct = c.HTML_INTEGRATION_POINTS || Ct, w = c.CUSTOM_ELEMENT_HANDLING || {}, c.CUSTOM_ELEMENT_HANDLING && jn(c.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (w.tagNameCheck = c.CUSTOM_ELEMENT_HANDLING.tagNameCheck), c.CUSTOM_ELEMENT_HANDLING && jn(c.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (w.attributeNameCheck = c.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), c.CUSTOM_ELEMENT_HANDLING && typeof c.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (w.allowCustomizedBuiltInElements = c.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), b && (G = !1), bt && (Ze = !0), Ke && (A = D({}, vr), C = [], Ke.html === !0 && (D(A, Er), D(C, br)), Ke.svg === !0 && (D(A, ln), D(C, dn), D(C, It)), Ke.svgFilters === !0 && (D(A, fn), D(C, dn), D(C, It)), Ke.mathMl === !0 && (D(A, un), D(C, Tr), D(C, It))), c.ADD_TAGS && (A === L && (A = He(A)), D(A, c.ADD_TAGS, ee)), c.ADD_ATTR && (C === I && (C = He(C)), D(C, c.ADD_ATTR, ee)), c.ADD_URI_SAFE_ATTR && D(Kt, c.ADD_URI_SAFE_ATTR, ee), c.FORBID_CONTENTS && (Je === Vn && (Je = He(Je)), D(Je, c.FORBID_CONTENTS, ee)), Zt && (A["#text"] = !0), ve && D(A, ["html", "head", "body"]), A.table && (D(A, ["tbody"]), delete N.tbody), c.TRUSTED_TYPES_POLICY) {
        if (typeof c.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw ut('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof c.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw ut('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        E = c.TRUSTED_TYPES_POLICY, d = E.createHTML("");
      } else
        E === void 0 && (E = ri(R, o)), E !== null && typeof d == "string" && (d = E.createHTML(""));
      ue && ue(c), Qe = c;
    }
  }, qn = D({}, [...ln, ...fn, ...qs]), Yn = D({}, [...un, ...Ys]), So = function(c) {
    let m = y(c);
    (!m || !m.tagName) && (m = {
      namespaceURI: Xe,
      tagName: "template"
    });
    const _ = Lt(c.tagName), X = Lt(m.tagName);
    return Xt[c.namespaceURI] ? c.namespaceURI === xt ? m.namespaceURI === Ne ? _ === "svg" : m.namespaceURI === _t ? _ === "svg" && (X === "annotation-xml" || St[X]) : !!qn[_] : c.namespaceURI === _t ? m.namespaceURI === Ne ? _ === "math" : m.namespaceURI === xt ? _ === "math" && Ct[X] : !!Yn[_] : c.namespaceURI === Ne ? m.namespaceURI === xt && !Ct[X] || m.namespaceURI === _t && !St[X] ? !1 : !Yn[_] && (bo[_] || !qn[_]) : !!(it === "application/xhtml+xml" && Xt[c.namespaceURI]) : !1;
  }, Ce = function(c) {
    lt(e.removed, {
      element: c
    });
    try {
      y(c).removeChild(c);
    } catch {
      v(c);
    }
  }, wt = function(c, m) {
    try {
      lt(e.removed, {
        attribute: m.getAttributeNode(c),
        from: m
      });
    } catch {
      lt(e.removed, {
        attribute: null,
        from: m
      });
    }
    if (m.removeAttribute(c), c === "is")
      if (Ze || bt)
        try {
          Ce(m);
        } catch {
        }
      else
        try {
          m.setAttribute(c, "");
        } catch {
        }
  }, Zn = function(c) {
    let m = null, _ = null;
    if (Yt)
      c = "<remove></remove>" + c;
    else {
      const oe = Ar(c, /^[\r\n\t ]+/);
      _ = oe && oe[0];
    }
    it === "application/xhtml+xml" && Xe === Ne && (c = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + c + "</body></html>");
    const X = E ? E.createHTML(c) : c;
    if (Xe === Ne)
      try {
        m = new T().parseFromString(X, it);
      } catch {
      }
    if (!m || !m.documentElement) {
      m = K.createDocument(Xe, "template", null);
      try {
        m.documentElement.innerHTML = Jt ? d : X;
      } catch {
      }
    }
    const se = m.body || m.documentElement;
    return c && _ && se.insertBefore(n.createTextNode(_), se.childNodes[0] || null), Xe === Ne ? ne.call(m, ve ? "html" : "body")[0] : ve ? m.documentElement : se;
  }, Kn = function(c) {
    return B.call(
      c.ownerDocument || c,
      c,
      // eslint-disable-next-line no-bitwise
      f.SHOW_ELEMENT | f.SHOW_COMMENT | f.SHOW_TEXT | f.SHOW_PROCESSING_INSTRUCTION | f.SHOW_CDATA_SECTION,
      null
    );
  }, $t = function(c) {
    return c instanceof g && (typeof c.nodeName != "string" || typeof c.textContent != "string" || typeof c.removeChild != "function" || !(c.attributes instanceof u) || typeof c.removeAttribute != "function" || typeof c.setAttribute != "function" || typeof c.namespaceURI != "string" || typeof c.insertBefore != "function" || typeof c.hasChildNodes != "function");
  }, Jn = function(c) {
    return typeof a == "function" && c instanceof a;
  };
  function Me(S, c, m) {
    kt(S, (_) => {
      _.call(e, c, m, Qe);
    });
  }
  const Xn = function(c) {
    let m = null;
    if (Me(j.beforeSanitizeElements, c, null), $t(c))
      return Ce(c), !0;
    const _ = ee(c.nodeName);
    if (Me(j.uponSanitizeElement, c, {
      tagName: _,
      allowedTags: A
    }), c.hasChildNodes() && !Jn(c.firstElementChild) && le(/<[/\w]/g, c.innerHTML) && le(/<[/\w]/g, c.textContent) || c.nodeType === pt.progressingInstruction || he && c.nodeType === pt.comment && le(/<[/\w]/g, c.data))
      return Ce(c), !0;
    if (!A[_] || N[_]) {
      if (!N[_] && $n(_) && (w.tagNameCheck instanceof RegExp && le(w.tagNameCheck, _) || w.tagNameCheck instanceof Function && w.tagNameCheck(_)))
        return !1;
      if (Zt && !Je[_]) {
        const X = y(c) || c.parentNode, se = p(c) || c.childNodes;
        if (se && X) {
          const oe = se.length;
          for (let me = oe - 1; me >= 0; --me) {
            const we = O(se[me], !0);
            we.__removalCount = (c.__removalCount || 0) + 1, X.insertBefore(we, x(c));
          }
        }
      }
      return Ce(c), !0;
    }
    return c instanceof l && !So(c) || (_ === "noscript" || _ === "noembed" || _ === "noframes") && le(/<\/no(script|embed|frames)/i, c.innerHTML) ? (Ce(c), !0) : (b && c.nodeType === pt.text && (m = c.textContent, kt([ie, ye, Ae], (X) => {
      m = ft(m, X, " ");
    }), c.textContent !== m && (lt(e.removed, {
      element: c.cloneNode()
    }), c.textContent = m)), Me(j.afterSanitizeElements, c, null), !1);
  }, Qn = function(c, m, _) {
    if (zn && (m === "id" || m === "name") && (_ in n || _ in xo))
      return !1;
    if (!(G && !M[m] && le(De, m))) {
      if (!(z && le(ae, m))) {
        if (!C[m] || M[m]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !($n(c) && (w.tagNameCheck instanceof RegExp && le(w.tagNameCheck, c) || w.tagNameCheck instanceof Function && w.tagNameCheck(c)) && (w.attributeNameCheck instanceof RegExp && le(w.attributeNameCheck, m) || w.attributeNameCheck instanceof Function && w.attributeNameCheck(m)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            m === "is" && w.allowCustomizedBuiltInElements && (w.tagNameCheck instanceof RegExp && le(w.tagNameCheck, _) || w.tagNameCheck instanceof Function && w.tagNameCheck(_)))
          ) return !1;
        } else if (!Kt[m]) {
          if (!le(h, ft(_, Ee, ""))) {
            if (!((m === "src" || m === "xlink:href" || m === "href") && c !== "script" && Gs(_, "data:") === 0 && Gn[c])) {
              if (!(U && !le(ge, ft(_, Ee, "")))) {
                if (_)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, $n = function(c) {
    return c !== "annotation-xml" && Ar(c, ot);
  }, er = function(c) {
    Me(j.beforeSanitizeAttributes, c, null);
    const {
      attributes: m
    } = c;
    if (!m || $t(c))
      return;
    const _ = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: C,
      forceKeepAttr: void 0
    };
    let X = m.length;
    for (; X--; ) {
      const se = m[X], {
        name: oe,
        namespaceURI: me,
        value: we
      } = se, at = ee(oe);
      let ce = oe === "value" ? we : Hs(we);
      if (_.attrName = at, _.attrValue = ce, _.keepAttr = !0, _.forceKeepAttr = void 0, Me(j.uponSanitizeAttribute, c, _), ce = _.attrValue, Un && (at === "id" || at === "name") && (wt(oe, c), ce = Eo + ce), he && le(/((--!?|])>)|<\/(style|title)/i, ce)) {
        wt(oe, c);
        continue;
      }
      if (_.forceKeepAttr || (wt(oe, c), !_.keepAttr))
        continue;
      if (!re && le(/\/>/i, ce)) {
        wt(oe, c);
        continue;
      }
      b && kt([ie, ye, Ae], (nr) => {
        ce = ft(ce, nr, " ");
      });
      const tr = ee(c.nodeName);
      if (Qn(tr, at, ce)) {
        if (E && typeof R == "object" && typeof R.getAttributeType == "function" && !me)
          switch (R.getAttributeType(tr, at)) {
            case "TrustedHTML": {
              ce = E.createHTML(ce);
              break;
            }
            case "TrustedScriptURL": {
              ce = E.createScriptURL(ce);
              break;
            }
          }
        try {
          me ? c.setAttributeNS(me, oe, ce) : c.setAttribute(oe, ce), $t(c) ? Ce(c) : yr(e.removed);
        } catch {
        }
      }
    }
    Me(j.afterSanitizeAttributes, c, null);
  }, Co = function S(c) {
    let m = null;
    const _ = Kn(c);
    for (Me(j.beforeSanitizeShadowDOM, c, null); m = _.nextNode(); )
      Me(j.uponSanitizeShadowNode, m, null), Xn(m), er(m), m.content instanceof s && S(m.content);
    Me(j.afterSanitizeShadowDOM, c, null);
  };
  return e.sanitize = function(S) {
    let c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, m = null, _ = null, X = null, se = null;
    if (Jt = !S, Jt && (S = "<!-->"), typeof S != "string" && !Jn(S))
      if (typeof S.toString == "function") {
        if (S = S.toString(), typeof S != "string")
          throw ut("dirty is not a string, aborting");
      } else
        throw ut("toString is not a function");
    if (!e.isSupported)
      return S;
    if (Ye || Qt(c), e.removed = [], typeof S == "string" && (st = !1), st) {
      if (S.nodeName) {
        const we = ee(S.nodeName);
        if (!A[we] || N[we])
          throw ut("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (S instanceof a)
      m = Zn("<!---->"), _ = m.ownerDocument.importNode(S, !0), _.nodeType === pt.element && _.nodeName === "BODY" || _.nodeName === "HTML" ? m = _ : m.appendChild(_);
    else {
      if (!Ze && !b && !ve && // eslint-disable-next-line unicorn/prefer-includes
      S.indexOf("<") === -1)
        return E && Tt ? E.createHTML(S) : S;
      if (m = Zn(S), !m)
        return Ze ? null : Tt ? d : "";
    }
    m && Yt && Ce(m.firstChild);
    const oe = Kn(st ? S : m);
    for (; X = oe.nextNode(); )
      Xn(X), er(X), X.content instanceof s && Co(X.content);
    if (st)
      return S;
    if (Ze) {
      if (bt)
        for (se = H.call(m.ownerDocument); m.firstChild; )
          se.appendChild(m.firstChild);
      else
        se = m;
      return (C.shadowroot || C.shadowrootmode) && (se = pe.call(r, se, !0)), se;
    }
    let me = ve ? m.outerHTML : m.innerHTML;
    return ve && A["!doctype"] && m.ownerDocument && m.ownerDocument.doctype && m.ownerDocument.doctype.name && le($r, m.ownerDocument.doctype.name) && (me = "<!DOCTYPE " + m.ownerDocument.doctype.name + `>
` + me), b && kt([ie, ye, Ae], (we) => {
      me = ft(me, we, " ");
    }), E && Tt ? E.createHTML(me) : me;
  }, e.setConfig = function() {
    let S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Qt(S), Ye = !0;
  }, e.clearConfig = function() {
    Qe = null, Ye = !1;
  }, e.isValidAttribute = function(S, c, m) {
    Qe || Qt({});
    const _ = ee(S), X = ee(c);
    return Qn(_, X, m);
  }, e.addHook = function(S, c) {
    typeof c == "function" && lt(j[S], c);
  }, e.removeHook = function(S, c) {
    if (c !== void 0) {
      const m = Us(j[S], c);
      return m === -1 ? void 0 : Vs(j[S], m, 1)[0];
    }
    return yr(j[S]);
  }, e.removeHooks = function(S) {
    j[S] = [];
  }, e.removeAllHooks = function() {
    j = xr();
  }, e;
}
var to = eo();
const oi = () => {
  const { sendMessage: t } = nt(), [e, n] = zt("");
  return {
    handleSendMessage: (o) => {
      var i;
      const s = to.sanitize(e.trim(), {
        ALLOWED_ATTR: [],
        ALLOWED_TAGS: []
      });
      !s || s.length === 0 || (t(s), n(""), o && ((i = o.current) == null || i.scrollIntoView({ behavior: "smooth" })));
    },
    inputMessage: e,
    setInputMessage: n
  };
};
function si({ messageContainerRef: t }) {
  const { handleSendMessage: e, inputMessage: n, setInputMessage: r } = oi(), { chatClosedByAgent: o, isConnected: s, loading: i } = nt(), a = Le(null);
  function l(g) {
    g.key === "Enter" && !g.shiftKey && (g.preventDefault(), e());
  }
  function f() {
    t.current && e(t);
  }
  const u = i || !s;
  if (!o)
    return /* @__PURE__ */ Oe(ii, { children: [
      /* @__PURE__ */ W(
        ci,
        {
          disabled: u,
          onChange: (g) => {
            r(g.target.value);
          },
          onKeyDown: l,
          placeholder: J.textInput.placeholder,
          ref: a,
          value: n
        }
      ),
      /* @__PURE__ */ W(ai, { disabled: u, onClick: f, children: /* @__PURE__ */ W("img", { alt: J.textInput.sendButton, src: Ds }) })
    ] });
}
const ii = te.div`
  display: flex;
  gap: 20px;
  padding-top: 16px;
  padding-bottom: 16px;
  align-items: center;
  flex-shrink: 0;
  border-top: 1px solid rgba(224, 224, 224, 1);
`, ai = te.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  svg {
    cursor: pointer;
  }
`, ci = te.textarea`
  height: auto;
  min-height: 55px;
  max-height: 150px;
  width: 100%;
  outline: none;
  resize: none;
  padding: 15px 15px;
  font-size: 0.95rem;
  gap: 10px;
  background-color: #fcfcfc;
  border-radius: 20px;
  border: 1px solid rgba(224, 224, 224, 1);
  overflow-y: auto;
  transition: height 0.2s ease;
`;
var Be = /* @__PURE__ */ ((t) => (t.Agent = "AGENT", t.Initiator = "INITIATOR", t.System = "SYSTEM", t))(Be || {});
function li({ message: t }) {
  const e = t.sender_type === Be.Initiator, n = fi(t.created_at);
  return t.sender_id === "system" ? /* @__PURE__ */ Oe(pi, { children: [
    /* @__PURE__ */ W("p", { children: Sr(t.text) }),
    n && /* @__PURE__ */ W("small", { children: n })
  ] }) : /* @__PURE__ */ Oe(ui, { $isOutgoing: e, "data-message-id": t.id, children: [
    /* @__PURE__ */ W("p", { children: Sr(t.text) }),
    e && /* @__PURE__ */ W(
      di,
      {
        $isReceived: t.is_received,
        title: t.is_received ? J.chatMessage.received : J.chatMessage.notReceived,
        children: "✓"
      }
    )
  ] });
}
function fi(t) {
  if (!t)
    return "";
  try {
    return new Date(t).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}
function Sr(t) {
  return to.sanitize(t, { ALLOWED_TAGS: [] });
}
const ui = te.li`
  display: flex;
  gap: 10px;
  margin: 10px;
  color: #333;
  justify-content: ${({ $isOutgoing: t }) => t ? "flex-end" : "flex-start"};

  p {
    white-space: pre-wrap;
    padding: 12px 16px;
    border-radius: ${({ $isOutgoing: t }) => t ? "10px 10px 0 10px" : "10px 10px 10px 0"};
    max-width: 75%;
    font-size: 0.95rem;
    overflow: auto;
    background: ${({ $isOutgoing: t }) => t ? "var(--message-outgoing-color, #FF9AF8)" : "var(--message-incoming-color, #F4F4F2)"};
  }
`, di = te.span`
  display: inline-block;
  font-size: 0.8em;
  opacity: ${({ $isReceived: t }) => t ? 1 : 0};
  align-self: flex-end;
  justify-content: flex-end;
  color: ${({ $isReceived: t }) => t ? "#0084ff" : "#9ca3af"};
`, pi = te.div`
  color: #808080;
  padding: 24px 0px;
  text-align: center;
  line-height: 1.5;
  font-size: 14px;
`;
function hi() {
  const { isOutsideWorkingHours: t, lastReadMessageId: e, messages: n } = nt(), r = Le(null), o = () => {
    const s = [];
    let i = !1;
    return n.forEach((a, l) => {
      s.push(/* @__PURE__ */ W(li, { message: a }, a.id)), !i && e && a.id === e && l !== n.length - 1 && (s.push(
        /* @__PURE__ */ W(mi, { children: /* @__PURE__ */ W("span", { children: J.messageList.newMessages }) }, `unread-before-${a.id}`)
      ), i = !0);
    }), s;
  };
  return ze(() => {
    r.current && r.current.scrollIntoView({ behavior: "smooth" });
  }, [n]), n.length === 0 ? /* @__PURE__ */ W(Cr, { children: /* @__PURE__ */ W(wr, { children: J.messageList.noMessages }) }) : /* @__PURE__ */ Oe(Cr, { children: [
    o(),
    t && /* @__PURE__ */ W(wr, { children: J.messageList.outsideWorkingHours }),
    /* @__PURE__ */ W("div", { ref: r })
  ] });
}
const Cr = te.ul`
  flex-grow: 1;
  overflow-y: auto;
  max-height: 400px;
  padding: var(--spacing-medium);
  background-color: var(--background-color);

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 25px;
  }
`, wr = te.div`
  color: #808080;
  padding: 24px 0px;
  text-align: center;
  line-height: 1.5;
  font-size: 14px;
`, mi = te.li`
  color: #808080;
  position: relative;
  text-align: center;
  background-color: #fff;
  padding: 12px 0px;
  z-index: 1;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    border-top: 1px solid #e0e0e0;
    z-index: -1;
  }

  span {
    background-color: #fff;
    padding: 0 10px;
  }
`;
function gi() {
  const { handleStartChat: t } = nt();
  return /* @__PURE__ */ Oe(yi, { children: [
    /* @__PURE__ */ W("h2", { children: J.welcome.title }),
    /* @__PURE__ */ W("p", { children: J.welcome.description }),
    /* @__PURE__ */ W("ul", { children: Object.entries(J.welcome.listItems).map(([e, n]) => /* @__PURE__ */ W("li", { children: n }, e)) }),
    /* @__PURE__ */ W(
      Ai,
      {
        onClick: () => {
          t();
        },
        children: J.welcome.buttonText
      }
    )
  ] });
}
const yi = te.div`
    text-align: left;
    padding: 0px 0px 24px 0px;
    background-color: white;
    color: #333;

    h2 {
        margin-top: 16px;
        font-size: 24px;
        margin-bottom: 12px;
    }

    p {
        margin-bottom: 12px;
    }

    ul {
        text-align: left;
        margin-bottom: 12px;
        padding-left: 24px;

        li {
            margin-bottom: 4px;
        }
    }
`, Ai = te.button`
    margin-top: 12px;
    background-color: var(--general-color, #007bff);
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 5px;
    transition: background-color 0.3s;

    &:hover {
        opacity: 0.9;
    }
`;
function Ei({ imageUrl: t }) {
  const { isChatOpen: e, loading: n, shouldShowWelcome: r } = nt(), o = Le(null);
  return /* @__PURE__ */ W(
    Mn,
    {
      classNames: "chat",
      in: e,
      nodeRef: o,
      timeout: 400,
      unmountOnExit: !0,
      children: /* @__PURE__ */ Oe(rr, { children: [
        /* @__PURE__ */ Oe(bi, { ref: o, children: [
          /* @__PURE__ */ W(Is, { logoImage: t }),
          r && !n ? /* @__PURE__ */ W(gi, {}) : /* @__PURE__ */ Oe(rr, { children: [
            n ? /* @__PURE__ */ W(vi, {}) : /* @__PURE__ */ W(hi, {}),
            /* @__PURE__ */ W(si, { messageContainerRef: o })
          ] })
        ] }),
        /* @__PURE__ */ W(
          ps,
          {
            autoClose: 3e3,
            closeOnClick: !0,
            draggable: !0,
            hideProgressBar: !0,
            newestOnTop: !1,
            pauseOnFocusLoss: !0,
            pauseOnHover: !0,
            position: "bottom-right",
            rtl: !1
          }
        )
      ] })
    }
  );
}
const vi = te.div`
    width: 20px;
    padding: 8px;
    aspect-ratio: 1;
    border-radius: 50%;
    background-color: var(--general-color, #007bff);
    --_m:
      conic-gradient(#0000 10%,#000),
      linear-gradient(#000 0 0) content-box;
    -webkit-mask: var(--_m);
            mask: var(--_m);
    -webkit-mask-composite: source-out;
            mask-composite: subtract;
    animation: l3 1s infinite linear;
  }
  @keyframes l3 {to{transform: rotate(1turn)}
`, bi = te.div`
  color: #333;
  position: fixed;
  bottom: 120px;
  right: 35px;
  width: calc(100% - 140px);
  max-width: 524px;
  max-height: calc(100vh - 240px);
  display: flex;
  flex-direction: column;
  padding: 32px 30px 0px 30px;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 0 128px 0 rgba(0, 0, 0, 0.1),
    0 32px 64px -48px rgba(0, 0, 0, 0.5);

  /* Enter Animation */
  &.chat-enter {
    opacity: 0;
    transform: scale(0.5);
  }
  &.chat-enter-active {
    opacity: 1;
    transform: scale(1);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  /* Exit Animation */
  &.chat-exit {
    opacity: 1;
    transform: scale(1);
  }
  &.chat-exit-active {
    opacity: 0;
    transform: scale(0.5);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }
`, Ti = "data:image/svg+xml,%3csvg%20width='23'%20height='23'%20viewBox='0%200%2023%2023'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M14.2866%2011.5006L22.0795%203.70764C22.4494%203.33844%2022.6574%202.83744%2022.6579%202.31485C22.6584%201.79226%2022.4512%201.29089%2022.082%200.921037C21.7128%200.551185%2021.2118%200.343144%2020.6892%200.342683C20.1666%200.342221%2019.6653%200.549376%2019.2954%200.918576L11.5024%208.71154L3.70947%200.918576C3.33962%200.548724%202.83799%200.340942%202.31494%200.340942C1.79189%200.340942%201.29026%200.548724%200.920407%200.918576C0.550555%201.28843%200.342773%201.79006%200.342773%202.31311C0.342773%202.83616%200.550555%203.33779%200.920407%203.70764L8.71338%2011.5006L0.920407%2019.2936C0.550555%2019.6634%200.342773%2020.1651%200.342773%2020.6881C0.342773%2021.2112%200.550555%2021.7128%200.920407%2022.0826C1.29026%2022.4525%201.79189%2022.6603%202.31494%2022.6603C2.83799%2022.6603%203.33962%2022.4525%203.70947%2022.0826L11.5024%2014.2897L19.2954%2022.0826C19.6653%2022.4525%2020.1669%2022.6603%2020.6899%2022.6603C21.213%2022.6603%2021.7146%2022.4525%2022.0845%2022.0826C22.4543%2021.7128%2022.6621%2021.2112%2022.6621%2020.6881C22.6621%2020.1651%2022.4543%2019.6634%2022.0845%2019.2936L14.2866%2011.5006Z'%20fill='%23F8F8F8'/%3e%3c/svg%3e", _i = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2037%2037'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M30.1466%204.21338C26.8364%201.56485%2022.7227%200.122847%2018.4834%200.124941C13.486%200.124941%208.81845%202.05021%205.32884%205.54639C1.95653%208.92936%200.108369%2013.396%200.123135%2018.1201C0.123249%2021.5837%201.14009%2024.9711%203.04755%2027.8622L3.06313%2027.8843C3.0861%2027.9179%203.10989%2027.9516%203.13368%2027.9844C3.15747%2028.0172%203.187%2028.0599%203.19356%2028.0705L3.21161%2028.1033C3.30431%2028.2674%203.37567%2028.4676%203.31251%2028.6694L1.80149%2034.1376C1.74104%2034.3409%201.70794%2034.5514%201.70306%2034.7635C1.70196%2035.3214%201.92216%2035.857%202.31536%2036.2528C2.70856%2036.6486%203.24268%2036.8723%203.8006%2036.8749C4.09541%2036.8652%204.38595%2036.8015%204.65782%2036.6871L10.1941%2034.6888L10.2638%2034.6617C10.4144%2034.5985%2010.5763%2034.5664%2010.7396%2034.5674C10.8902%2034.5678%2011.0395%2034.5956%2011.1801%2034.6494C11.313%2034.7011%2012.5197%2035.1629%2013.7928%2035.519C14.851%2035.8143%2017.0527%2036.2572%2018.7779%2036.2572C23.671%2036.2572%2028.2402%2034.3623%2031.6428%2030.9203C35.0159%2027.5045%2036.8731%2022.9641%2036.8731%2018.13C36.8736%2016.8891%2036.7421%2015.6517%2036.481%2014.4386C35.6328%2010.4502%2033.3835%206.81787%2030.1466%204.21338ZM10.6231%2021.1249C10.104%2021.1249%209.59644%2020.971%209.16476%2020.6825C8.73308%2020.3941%208.39663%2019.9841%208.19795%2019.5045C7.99927%2019.0248%207.94729%2018.497%208.04857%2017.9878C8.14986%2017.4786%208.39987%2017.0109%208.76698%2016.6438C9.13409%2016.2767%209.60182%2016.0267%2010.111%2015.9254C10.6202%2015.8241%2011.148%2015.8761%2011.6277%2016.0748C12.1073%2016.2734%2012.5173%2016.6099%2012.8057%2017.0416C13.0942%2017.4732%2013.2481%2017.9808%2013.2481%2018.4999C13.2481%2019.1961%2012.9716%2019.8638%2012.4793%2020.3561C11.987%2020.8484%2011.3193%2021.1249%2010.6231%2021.1249ZM18.4981%2021.1249C17.979%2021.1249%2017.4714%2020.971%2017.0398%2020.6825C16.6081%2020.3941%2016.2716%2019.9841%2016.073%2019.5045C15.8743%2019.0248%2015.8223%2018.497%2015.9236%2017.9878C16.0249%2017.4786%2016.2749%2017.0109%2016.642%2016.6438C17.0091%2016.2767%2017.4768%2016.0267%2017.986%2015.9254C18.4952%2015.8241%2019.023%2015.8761%2019.5027%2016.0748C19.9823%2016.2734%2020.3923%2016.6099%2020.6807%2017.0416C20.9692%2017.4732%2021.1231%2017.9808%2021.1231%2018.4999C21.1231%2019.1961%2020.8466%2019.8638%2020.3543%2020.3561C19.862%2020.8484%2019.1943%2021.1249%2018.4981%2021.1249ZM26.3731%2021.1249C25.854%2021.1249%2025.3464%2020.971%2024.9148%2020.6825C24.4831%2020.3941%2024.1466%2019.9841%2023.948%2019.5045C23.7493%2019.0248%2023.6973%2018.497%2023.7986%2017.9878C23.8999%2017.4786%2024.1499%2017.0109%2024.517%2016.6438C24.8841%2016.2767%2025.3518%2016.0267%2025.861%2015.9254C26.3702%2015.8241%2026.898%2015.8761%2027.3777%2016.0748C27.8573%2016.2734%2028.2673%2016.6099%2028.5557%2017.0416C28.8442%2017.4732%2028.9981%2017.9808%2028.9981%2018.4999C28.9981%2019.1961%2028.7216%2019.8638%2028.2293%2020.3561C27.737%2020.8484%2027.0693%2021.1249%2026.3731%2021.1249Z'%20fill='%23F8F8F8'/%3e%3c/svg%3e";
var no = /* @__PURE__ */ ((t) => (t.JOIN = "join", t.MARK_ALL_MESSAGES_AS_READ = "readMessages", t.MESSAGE_RECEIVED = "message-received", t.SEND_MESSAGE = "sendMessageInThread", t.USER_CONNECTED = "userConnected", t.USER_DISCONNECTED = "userDisconnected", t))(no || {}), Fe = /* @__PURE__ */ ((t) => (t.CHAT_CLOSED = "close", t.CONNECT = "connect", t.CONNECT_ERROR = "connect_error", t.DISCONNECT = "disconnect", t.ERROR = "error", t.MESSAGE = "message", t.MESSAGE_RECEIVED = "message-received", t))(Fe || {});
function xi(t, e) {
  vt(t, "join", e);
}
function Si(t, e) {
  vt(t, "readMessages", e);
}
function Ci(t, e) {
  vt(t, "message-received", e);
}
function wi(t, e) {
  vt(t, "sendMessageInThread", e);
}
function Or(t, e) {
  vt(t, "userDisconnected", e);
}
function vt(t, e, n) {
  t.emit(e, n);
}
const tt = {
  accessToken: "widget_access_token",
  threadId: "widget_thread_id"
}, xe = () => localStorage.getItem(tt.threadId), We = () => localStorage.getItem(tt.accessToken), Oi = (t, e) => {
  localStorage.setItem(tt.threadId, t), localStorage.setItem(tt.accessToken, e);
}, ro = () => {
  localStorage.removeItem(tt.threadId), localStorage.removeItem(tt.accessToken);
};
async function Ri({
  apiUrl: t,
  initiatorId: e,
  name: n,
  organisationId: r,
  useProxy: o = !1
}) {
  const s = localStorage.getItem("widget_thread_id"), i = localStorage.getItem("widget_access_token");
  if (s && i)
    return {
      accessToken: i,
      status: 200,
      // Already initialized
      threadId: s
    };
  try {
    if (!e || !n || !r)
      throw new Error(
        "Missing required fields: initiatorId, name, or organisationId"
      );
    const l = `${o ? "/" : t}api/threads/create`, f = await fetch(l, {
      body: JSON.stringify({
        initiator_id: e,
        name: n,
        organisation_id: r
      }),
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      method: "POST"
    }), u = await f.json();
    return f.ok && u.thread_id && u.access_token ? {
      accessToken: u.access_token,
      greeting: u.greeting,
      isReceived: u.is_received,
      status: f.status,
      threadId: u.thread_id
    } : f.status === 503 && u.message === "Outside working hours" ? {
      error: "Outside working hours",
      status: f.status,
      workingHoursEnd: u.working_hours_end,
      workingHoursStart: u.working_hours_start
    } : {
      error: "Failed to initialize chat",
      status: f.status
    };
  } catch (a) {
    return console.error("Error creating thread:", a), {
      error: "An unexpected error occurred",
      status: 500
    };
  }
}
const ke = /* @__PURE__ */ Object.create(null);
ke.open = "0";
ke.close = "1";
ke.ping = "2";
ke.pong = "3";
ke.message = "4";
ke.upgrade = "5";
ke.noop = "6";
const Pt = /* @__PURE__ */ Object.create(null);
Object.keys(ke).forEach((t) => {
  Pt[ke[t]] = t;
});
const Sn = { type: "error", data: "parser error" }, oo = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", so = typeof ArrayBuffer == "function", io = (t) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(t) : t && t.buffer instanceof ArrayBuffer, Ln = ({ type: t, data: e }, n, r) => oo && e instanceof Blob ? n ? r(e) : Rr(e, r) : so && (e instanceof ArrayBuffer || io(e)) ? n ? r(e) : Rr(new Blob([e]), r) : r(ke[t] + (e || "")), Rr = (t, e) => {
  const n = new FileReader();
  return n.onload = function() {
    const r = n.result.split(",")[1];
    e("b" + (r || ""));
  }, n.readAsDataURL(t);
};
function kr(t) {
  return t instanceof Uint8Array ? t : t instanceof ArrayBuffer ? new Uint8Array(t) : new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
}
let pn;
function ki(t, e) {
  if (oo && t.data instanceof Blob)
    return t.data.arrayBuffer().then(kr).then(e);
  if (so && (t.data instanceof ArrayBuffer || io(t.data)))
    return e(kr(t.data));
  Ln(t, !1, (n) => {
    pn || (pn = new TextEncoder()), e(pn.encode(n));
  });
}
const Ir = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", gt = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let t = 0; t < Ir.length; t++)
  gt[Ir.charCodeAt(t)] = t;
const Ii = (t) => {
  let e = t.length * 0.75, n = t.length, r, o = 0, s, i, a, l;
  t[t.length - 1] === "=" && (e--, t[t.length - 2] === "=" && e--);
  const f = new ArrayBuffer(e), u = new Uint8Array(f);
  for (r = 0; r < n; r += 4)
    s = gt[t.charCodeAt(r)], i = gt[t.charCodeAt(r + 1)], a = gt[t.charCodeAt(r + 2)], l = gt[t.charCodeAt(r + 3)], u[o++] = s << 2 | i >> 4, u[o++] = (i & 15) << 4 | a >> 2, u[o++] = (a & 3) << 6 | l & 63;
  return f;
}, Ni = typeof ArrayBuffer == "function", Pn = (t, e) => {
  if (typeof t != "string")
    return {
      type: "message",
      data: ao(t, e)
    };
  const n = t.charAt(0);
  return n === "b" ? {
    type: "message",
    data: Mi(t.substring(1), e)
  } : Pt[n] ? t.length > 1 ? {
    type: Pt[n],
    data: t.substring(1)
  } : {
    type: Pt[n]
  } : Sn;
}, Mi = (t, e) => {
  if (Ni) {
    const n = Ii(t);
    return ao(n, e);
  } else
    return { base64: !0, data: t };
}, ao = (t, e) => {
  switch (e) {
    case "blob":
      return t instanceof Blob ? t : new Blob([t]);
    case "arraybuffer":
    default:
      return t instanceof ArrayBuffer ? t : t.buffer;
  }
}, co = "", Li = (t, e) => {
  const n = t.length, r = new Array(n);
  let o = 0;
  t.forEach((s, i) => {
    Ln(s, !1, (a) => {
      r[i] = a, ++o === n && e(r.join(co));
    });
  });
}, Pi = (t, e) => {
  const n = t.split(co), r = [];
  for (let o = 0; o < n.length; o++) {
    const s = Pn(n[o], e);
    if (r.push(s), s.type === "error")
      break;
  }
  return r;
};
function Di() {
  return new TransformStream({
    transform(t, e) {
      ki(t, (n) => {
        const r = n.length;
        let o;
        if (r < 126)
          o = new Uint8Array(1), new DataView(o.buffer).setUint8(0, r);
        else if (r < 65536) {
          o = new Uint8Array(3);
          const s = new DataView(o.buffer);
          s.setUint8(0, 126), s.setUint16(1, r);
        } else {
          o = new Uint8Array(9);
          const s = new DataView(o.buffer);
          s.setUint8(0, 127), s.setBigUint64(1, BigInt(r));
        }
        t.data && typeof t.data != "string" && (o[0] |= 128), e.enqueue(o), e.enqueue(n);
      });
    }
  });
}
let hn;
function Nt(t) {
  return t.reduce((e, n) => e + n.length, 0);
}
function Mt(t, e) {
  if (t[0].length === e)
    return t.shift();
  const n = new Uint8Array(e);
  let r = 0;
  for (let o = 0; o < e; o++)
    n[o] = t[0][r++], r === t[0].length && (t.shift(), r = 0);
  return t.length && r < t[0].length && (t[0] = t[0].slice(r)), n;
}
function Bi(t, e) {
  hn || (hn = new TextDecoder());
  const n = [];
  let r = 0, o = -1, s = !1;
  return new TransformStream({
    transform(i, a) {
      for (n.push(i); ; ) {
        if (r === 0) {
          if (Nt(n) < 1)
            break;
          const l = Mt(n, 1);
          s = (l[0] & 128) === 128, o = l[0] & 127, o < 126 ? r = 3 : o === 126 ? r = 1 : r = 2;
        } else if (r === 1) {
          if (Nt(n) < 2)
            break;
          const l = Mt(n, 2);
          o = new DataView(l.buffer, l.byteOffset, l.length).getUint16(0), r = 3;
        } else if (r === 2) {
          if (Nt(n) < 8)
            break;
          const l = Mt(n, 8), f = new DataView(l.buffer, l.byteOffset, l.length), u = f.getUint32(0);
          if (u > Math.pow(2, 21) - 1) {
            a.enqueue(Sn);
            break;
          }
          o = u * Math.pow(2, 32) + f.getUint32(4), r = 3;
        } else {
          if (Nt(n) < o)
            break;
          const l = Mt(n, o);
          a.enqueue(Pn(s ? l : hn.decode(l), e)), r = 0;
        }
        if (o === 0 || o > t) {
          a.enqueue(Sn);
          break;
        }
      }
    }
  });
}
const lo = 4;
function $(t) {
  if (t) return Wi(t);
}
function Wi(t) {
  for (var e in $.prototype)
    t[e] = $.prototype[e];
  return t;
}
$.prototype.on = $.prototype.addEventListener = function(t, e) {
  return this._callbacks = this._callbacks || {}, (this._callbacks["$" + t] = this._callbacks["$" + t] || []).push(e), this;
};
$.prototype.once = function(t, e) {
  function n() {
    this.off(t, n), e.apply(this, arguments);
  }
  return n.fn = e, this.on(t, n), this;
};
$.prototype.off = $.prototype.removeListener = $.prototype.removeAllListeners = $.prototype.removeEventListener = function(t, e) {
  if (this._callbacks = this._callbacks || {}, arguments.length == 0)
    return this._callbacks = {}, this;
  var n = this._callbacks["$" + t];
  if (!n) return this;
  if (arguments.length == 1)
    return delete this._callbacks["$" + t], this;
  for (var r, o = 0; o < n.length; o++)
    if (r = n[o], r === e || r.fn === e) {
      n.splice(o, 1);
      break;
    }
  return n.length === 0 && delete this._callbacks["$" + t], this;
};
$.prototype.emit = function(t) {
  this._callbacks = this._callbacks || {};
  for (var e = new Array(arguments.length - 1), n = this._callbacks["$" + t], r = 1; r < arguments.length; r++)
    e[r - 1] = arguments[r];
  if (n) {
    n = n.slice(0);
    for (var r = 0, o = n.length; r < o; ++r)
      n[r].apply(this, e);
  }
  return this;
};
$.prototype.emitReserved = $.prototype.emit;
$.prototype.listeners = function(t) {
  return this._callbacks = this._callbacks || {}, this._callbacks["$" + t] || [];
};
$.prototype.hasListeners = function(t) {
  return !!this.listeners(t).length;
};
const jt = typeof Promise == "function" && typeof Promise.resolve == "function" ? (e) => Promise.resolve().then(e) : (e, n) => n(e, 0), be = typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")(), zi = "arraybuffer";
function fo(t, ...e) {
  return e.reduce((n, r) => (t.hasOwnProperty(r) && (n[r] = t[r]), n), {});
}
const Ui = be.setTimeout, Vi = be.clearTimeout;
function qt(t, e) {
  e.useNativeTimers ? (t.setTimeoutFn = Ui.bind(be), t.clearTimeoutFn = Vi.bind(be)) : (t.setTimeoutFn = be.setTimeout.bind(be), t.clearTimeoutFn = be.clearTimeout.bind(be));
}
const Gi = 1.33;
function Hi(t) {
  return typeof t == "string" ? Fi(t) : Math.ceil((t.byteLength || t.size) * Gi);
}
function Fi(t) {
  let e = 0, n = 0;
  for (let r = 0, o = t.length; r < o; r++)
    e = t.charCodeAt(r), e < 128 ? n += 1 : e < 2048 ? n += 2 : e < 55296 || e >= 57344 ? n += 3 : (r++, n += 4);
  return n;
}
function uo() {
  return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
function ji(t) {
  let e = "";
  for (let n in t)
    t.hasOwnProperty(n) && (e.length && (e += "&"), e += encodeURIComponent(n) + "=" + encodeURIComponent(t[n]));
  return e;
}
function qi(t) {
  let e = {}, n = t.split("&");
  for (let r = 0, o = n.length; r < o; r++) {
    let s = n[r].split("=");
    e[decodeURIComponent(s[0])] = decodeURIComponent(s[1]);
  }
  return e;
}
class Yi extends Error {
  constructor(e, n, r) {
    super(e), this.description = n, this.context = r, this.type = "TransportError";
  }
}
class Dn extends $ {
  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  constructor(e) {
    super(), this.writable = !1, qt(this, e), this.opts = e, this.query = e.query, this.socket = e.socket, this.supportsBinary = !e.forceBase64;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */
  onError(e, n, r) {
    return super.emitReserved("error", new Yi(e, n, r)), this;
  }
  /**
   * Opens the transport.
   */
  open() {
    return this.readyState = "opening", this.doOpen(), this;
  }
  /**
   * Closes the transport.
   */
  close() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }
  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */
  send(e) {
    this.readyState === "open" && this.write(e);
  }
  /**
   * Called upon open
   *
   * @protected
   */
  onOpen() {
    this.readyState = "open", this.writable = !0, super.emitReserved("open");
  }
  /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */
  onData(e) {
    const n = Pn(e, this.socket.binaryType);
    this.onPacket(n);
  }
  /**
   * Called with a decoded packet.
   *
   * @protected
   */
  onPacket(e) {
    super.emitReserved("packet", e);
  }
  /**
   * Called upon close.
   *
   * @protected
   */
  onClose(e) {
    this.readyState = "closed", super.emitReserved("close", e);
  }
  /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */
  pause(e) {
  }
  createUri(e, n = {}) {
    return e + "://" + this._hostname() + this._port() + this.opts.path + this._query(n);
  }
  _hostname() {
    const e = this.opts.hostname;
    return e.indexOf(":") === -1 ? e : "[" + e + "]";
  }
  _port() {
    return this.opts.port && (this.opts.secure && +(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
  }
  _query(e) {
    const n = ji(e);
    return n.length ? "?" + n : "";
  }
}
class Zi extends Dn {
  constructor() {
    super(...arguments), this._polling = !1;
  }
  get name() {
    return "polling";
  }
  /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */
  doOpen() {
    this._poll();
  }
  /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */
  pause(e) {
    this.readyState = "pausing";
    const n = () => {
      this.readyState = "paused", e();
    };
    if (this._polling || !this.writable) {
      let r = 0;
      this._polling && (r++, this.once("pollComplete", function() {
        --r || n();
      })), this.writable || (r++, this.once("drain", function() {
        --r || n();
      }));
    } else
      n();
  }
  /**
   * Starts polling cycle.
   *
   * @private
   */
  _poll() {
    this._polling = !0, this.doPoll(), this.emitReserved("poll");
  }
  /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */
  onData(e) {
    const n = (r) => {
      if (this.readyState === "opening" && r.type === "open" && this.onOpen(), r.type === "close")
        return this.onClose({ description: "transport closed by the server" }), !1;
      this.onPacket(r);
    };
    Pi(e, this.socket.binaryType).forEach(n), this.readyState !== "closed" && (this._polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this._poll());
  }
  /**
   * For polling, send a close packet.
   *
   * @protected
   */
  doClose() {
    const e = () => {
      this.write([{ type: "close" }]);
    };
    this.readyState === "open" ? e() : this.once("open", e);
  }
  /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */
  write(e) {
    this.writable = !1, Li(e, (n) => {
      this.doWrite(n, () => {
        this.writable = !0, this.emitReserved("drain");
      });
    });
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const e = this.opts.secure ? "https" : "http", n = this.query || {};
    return this.opts.timestampRequests !== !1 && (n[this.opts.timestampParam] = uo()), !this.supportsBinary && !n.sid && (n.b64 = 1), this.createUri(e, n);
  }
}
let po = !1;
try {
  po = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {
}
const Ki = po;
function Ji() {
}
class Xi extends Zi {
  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */
  constructor(e) {
    if (super(e), typeof location < "u") {
      const n = location.protocol === "https:";
      let r = location.port;
      r || (r = n ? "443" : "80"), this.xd = typeof location < "u" && e.hostname !== location.hostname || r !== e.port;
    }
  }
  /**
   * Sends data.
   *
   * @param {String} data to send.
   * @param {Function} called upon flush.
   * @private
   */
  doWrite(e, n) {
    const r = this.request({
      method: "POST",
      data: e
    });
    r.on("success", n), r.on("error", (o, s) => {
      this.onError("xhr post error", o, s);
    });
  }
  /**
   * Starts a poll cycle.
   *
   * @private
   */
  doPoll() {
    const e = this.request();
    e.on("data", this.onData.bind(this)), e.on("error", (n, r) => {
      this.onError("xhr poll error", n, r);
    }), this.pollXhr = e;
  }
}
class Re extends $ {
  /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */
  constructor(e, n, r) {
    super(), this.createRequest = e, qt(this, r), this._opts = r, this._method = r.method || "GET", this._uri = n, this._data = r.data !== void 0 ? r.data : null, this._create();
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */
  _create() {
    var e;
    const n = fo(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    n.xdomain = !!this._opts.xd;
    const r = this._xhr = this.createRequest(n);
    try {
      r.open(this._method, this._uri, !0);
      try {
        if (this._opts.extraHeaders) {
          r.setDisableHeaderCheck && r.setDisableHeaderCheck(!0);
          for (let o in this._opts.extraHeaders)
            this._opts.extraHeaders.hasOwnProperty(o) && r.setRequestHeader(o, this._opts.extraHeaders[o]);
        }
      } catch {
      }
      if (this._method === "POST")
        try {
          r.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        r.setRequestHeader("Accept", "*/*");
      } catch {
      }
      (e = this._opts.cookieJar) === null || e === void 0 || e.addCookies(r), "withCredentials" in r && (r.withCredentials = this._opts.withCredentials), this._opts.requestTimeout && (r.timeout = this._opts.requestTimeout), r.onreadystatechange = () => {
        var o;
        r.readyState === 3 && ((o = this._opts.cookieJar) === null || o === void 0 || o.parseCookies(
          // @ts-ignore
          r.getResponseHeader("set-cookie")
        )), r.readyState === 4 && (r.status === 200 || r.status === 1223 ? this._onLoad() : this.setTimeoutFn(() => {
          this._onError(typeof r.status == "number" ? r.status : 0);
        }, 0));
      }, r.send(this._data);
    } catch (o) {
      this.setTimeoutFn(() => {
        this._onError(o);
      }, 0);
      return;
    }
    typeof document < "u" && (this._index = Re.requestsCount++, Re.requests[this._index] = this);
  }
  /**
   * Called upon error.
   *
   * @private
   */
  _onError(e) {
    this.emitReserved("error", e, this._xhr), this._cleanup(!0);
  }
  /**
   * Cleans up house.
   *
   * @private
   */
  _cleanup(e) {
    if (!(typeof this._xhr > "u" || this._xhr === null)) {
      if (this._xhr.onreadystatechange = Ji, e)
        try {
          this._xhr.abort();
        } catch {
        }
      typeof document < "u" && delete Re.requests[this._index], this._xhr = null;
    }
  }
  /**
   * Called upon load.
   *
   * @private
   */
  _onLoad() {
    const e = this._xhr.responseText;
    e !== null && (this.emitReserved("data", e), this.emitReserved("success"), this._cleanup());
  }
  /**
   * Aborts the request.
   *
   * @package
   */
  abort() {
    this._cleanup();
  }
}
Re.requestsCount = 0;
Re.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", Nr);
  else if (typeof addEventListener == "function") {
    const t = "onpagehide" in be ? "pagehide" : "unload";
    addEventListener(t, Nr, !1);
  }
}
function Nr() {
  for (let t in Re.requests)
    Re.requests.hasOwnProperty(t) && Re.requests[t].abort();
}
const Qi = function() {
  const t = ho({
    xdomain: !1
  });
  return t && t.responseType !== null;
}();
class $i extends Xi {
  constructor(e) {
    super(e);
    const n = e && e.forceBase64;
    this.supportsBinary = Qi && !n;
  }
  request(e = {}) {
    return Object.assign(e, { xd: this.xd }, this.opts), new Re(ho, this.uri(), e);
  }
}
function ho(t) {
  const e = t.xdomain;
  try {
    if (typeof XMLHttpRequest < "u" && (!e || Ki))
      return new XMLHttpRequest();
  } catch {
  }
  if (!e)
    try {
      return new be[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}
const mo = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
class ea extends Dn {
  get name() {
    return "websocket";
  }
  doOpen() {
    const e = this.uri(), n = this.opts.protocols, r = mo ? {} : fo(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    this.opts.extraHeaders && (r.headers = this.opts.extraHeaders);
    try {
      this.ws = this.createSocket(e, n, r);
    } catch (o) {
      return this.emitReserved("error", o);
    }
    this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
  }
  /**
   * Adds event listeners to the socket
   *
   * @private
   */
  addEventListeners() {
    this.ws.onopen = () => {
      this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
    }, this.ws.onclose = (e) => this.onClose({
      description: "websocket connection closed",
      context: e
    }), this.ws.onmessage = (e) => this.onData(e.data), this.ws.onerror = (e) => this.onError("websocket error", e);
  }
  write(e) {
    this.writable = !1;
    for (let n = 0; n < e.length; n++) {
      const r = e[n], o = n === e.length - 1;
      Ln(r, this.supportsBinary, (s) => {
        try {
          this.doWrite(r, s);
        } catch {
        }
        o && jt(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    typeof this.ws < "u" && (this.ws.onerror = () => {
    }, this.ws.close(), this.ws = null);
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const e = this.opts.secure ? "wss" : "ws", n = this.query || {};
    return this.opts.timestampRequests && (n[this.opts.timestampParam] = uo()), this.supportsBinary || (n.b64 = 1), this.createUri(e, n);
  }
}
const mn = be.WebSocket || be.MozWebSocket;
class ta extends ea {
  createSocket(e, n, r) {
    return mo ? new mn(e, n, r) : n ? new mn(e, n) : new mn(e);
  }
  doWrite(e, n) {
    this.ws.send(n);
  }
}
class na extends Dn {
  get name() {
    return "webtransport";
  }
  doOpen() {
    try {
      this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
    } catch (e) {
      return this.emitReserved("error", e);
    }
    this._transport.closed.then(() => {
      this.onClose();
    }).catch((e) => {
      this.onError("webtransport error", e);
    }), this._transport.ready.then(() => {
      this._transport.createBidirectionalStream().then((e) => {
        const n = Bi(Number.MAX_SAFE_INTEGER, this.socket.binaryType), r = e.readable.pipeThrough(n).getReader(), o = Di();
        o.readable.pipeTo(e.writable), this._writer = o.writable.getWriter();
        const s = () => {
          r.read().then(({ done: a, value: l }) => {
            a || (this.onPacket(l), s());
          }).catch((a) => {
          });
        };
        s();
        const i = { type: "open" };
        this.query.sid && (i.data = `{"sid":"${this.query.sid}"}`), this._writer.write(i).then(() => this.onOpen());
      });
    });
  }
  write(e) {
    this.writable = !1;
    for (let n = 0; n < e.length; n++) {
      const r = e[n], o = n === e.length - 1;
      this._writer.write(r).then(() => {
        o && jt(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    var e;
    (e = this._transport) === null || e === void 0 || e.close();
  }
}
const ra = {
  websocket: ta,
  webtransport: na,
  polling: $i
}, oa = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, sa = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function Cn(t) {
  if (t.length > 8e3)
    throw "URI too long";
  const e = t, n = t.indexOf("["), r = t.indexOf("]");
  n != -1 && r != -1 && (t = t.substring(0, n) + t.substring(n, r).replace(/:/g, ";") + t.substring(r, t.length));
  let o = oa.exec(t || ""), s = {}, i = 14;
  for (; i--; )
    s[sa[i]] = o[i] || "";
  return n != -1 && r != -1 && (s.source = e, s.host = s.host.substring(1, s.host.length - 1).replace(/;/g, ":"), s.authority = s.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), s.ipv6uri = !0), s.pathNames = ia(s, s.path), s.queryKey = aa(s, s.query), s;
}
function ia(t, e) {
  const n = /\/{2,9}/g, r = e.replace(n, "/").split("/");
  return (e.slice(0, 1) == "/" || e.length === 0) && r.splice(0, 1), e.slice(-1) == "/" && r.splice(r.length - 1, 1), r;
}
function aa(t, e) {
  const n = {};
  return e.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(r, o, s) {
    o && (n[o] = s);
  }), n;
}
const wn = typeof addEventListener == "function" && typeof removeEventListener == "function", Dt = [];
wn && addEventListener("offline", () => {
  Dt.forEach((t) => t());
}, !1);
class Ue extends $ {
  /**
   * Socket constructor.
   *
   * @param {String|Object} uri - uri or options
   * @param {Object} opts - options
   */
  constructor(e, n) {
    if (super(), this.binaryType = zi, this.writeBuffer = [], this._prevBufferLen = 0, this._pingInterval = -1, this._pingTimeout = -1, this._maxPayload = -1, this._pingTimeoutTime = 1 / 0, e && typeof e == "object" && (n = e, e = null), e) {
      const r = Cn(e);
      n.hostname = r.host, n.secure = r.protocol === "https" || r.protocol === "wss", n.port = r.port, r.query && (n.query = r.query);
    } else n.host && (n.hostname = Cn(n.host).host);
    qt(this, n), this.secure = n.secure != null ? n.secure : typeof location < "u" && location.protocol === "https:", n.hostname && !n.port && (n.port = this.secure ? "443" : "80"), this.hostname = n.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = n.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = [], this._transportsByName = {}, n.transports.forEach((r) => {
      const o = r.prototype.name;
      this.transports.push(o), this._transportsByName[o] = r;
    }), this.opts = Object.assign({
      path: "/engine.io",
      agent: !1,
      withCredentials: !1,
      upgrade: !0,
      timestampParam: "t",
      rememberUpgrade: !1,
      addTrailingSlash: !0,
      rejectUnauthorized: !0,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: !1
    }, n), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = qi(this.opts.query)), wn && (this.opts.closeOnBeforeunload && (this._beforeunloadEventListener = () => {
      this.transport && (this.transport.removeAllListeners(), this.transport.close());
    }, addEventListener("beforeunload", this._beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this._offlineEventListener = () => {
      this._onClose("transport close", {
        description: "network connection lost"
      });
    }, Dt.push(this._offlineEventListener))), this.opts.withCredentials && (this._cookieJar = void 0), this._open();
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */
  createTransport(e) {
    const n = Object.assign({}, this.opts.query);
    n.EIO = lo, n.transport = e, this.id && (n.sid = this.id);
    const r = Object.assign({}, this.opts, {
      query: n,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    }, this.opts.transportOptions[e]);
    return new this._transportsByName[e](r);
  }
  /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */
  _open() {
    if (this.transports.length === 0) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    }
    const e = this.opts.rememberUpgrade && Ue.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
    this.readyState = "opening";
    const n = this.createTransport(e);
    n.open(), this.setTransport(n);
  }
  /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */
  setTransport(e) {
    this.transport && this.transport.removeAllListeners(), this.transport = e, e.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (n) => this._onClose("transport close", n));
  }
  /**
   * Called when connection is deemed open.
   *
   * @private
   */
  onOpen() {
    this.readyState = "open", Ue.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush();
  }
  /**
   * Handles a packet.
   *
   * @private
   */
  _onPacket(e) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (this.emitReserved("packet", e), this.emitReserved("heartbeat"), e.type) {
        case "open":
          this.onHandshake(JSON.parse(e.data));
          break;
        case "ping":
          this._sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong"), this._resetPingTimeout();
          break;
        case "error":
          const n = new Error("server error");
          n.code = e.data, this._onError(n);
          break;
        case "message":
          this.emitReserved("data", e.data), this.emitReserved("message", e.data);
          break;
      }
  }
  /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */
  onHandshake(e) {
    this.emitReserved("handshake", e), this.id = e.sid, this.transport.query.sid = e.sid, this._pingInterval = e.pingInterval, this._pingTimeout = e.pingTimeout, this._maxPayload = e.maxPayload, this.onOpen(), this.readyState !== "closed" && this._resetPingTimeout();
  }
  /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */
  _resetPingTimeout() {
    this.clearTimeoutFn(this._pingTimeoutTimer);
    const e = this._pingInterval + this._pingTimeout;
    this._pingTimeoutTime = Date.now() + e, this._pingTimeoutTimer = this.setTimeoutFn(() => {
      this._onClose("ping timeout");
    }, e), this.opts.autoUnref && this._pingTimeoutTimer.unref();
  }
  /**
   * Called on `drain` event
   *
   * @private
   */
  _onDrain() {
    this.writeBuffer.splice(0, this._prevBufferLen), this._prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
  }
  /**
   * Flush write buffers.
   *
   * @private
   */
  flush() {
    if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const e = this._getWritablePackets();
      this.transport.send(e), this._prevBufferLen = e.length, this.emitReserved("flush");
    }
  }
  /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */
  _getWritablePackets() {
    if (!(this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1))
      return this.writeBuffer;
    let n = 1;
    for (let r = 0; r < this.writeBuffer.length; r++) {
      const o = this.writeBuffer[r].data;
      if (o && (n += Hi(o)), r > 0 && n > this._maxPayload)
        return this.writeBuffer.slice(0, r);
      n += 2;
    }
    return this.writeBuffer;
  }
  /**
   * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
   *
   * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
   * `write()` method then the message would not be buffered by the Socket.IO client.
   *
   * @return {boolean}
   * @private
   */
  /* private */
  _hasPingExpired() {
    if (!this._pingTimeoutTime)
      return !0;
    const e = Date.now() > this._pingTimeoutTime;
    return e && (this._pingTimeoutTime = 0, jt(() => {
      this._onClose("ping timeout");
    }, this.setTimeoutFn)), e;
  }
  /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  write(e, n, r) {
    return this._sendPacket("message", e, n, r), this;
  }
  /**
   * Sends a message. Alias of {@link Socket#write}.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  send(e, n, r) {
    return this._sendPacket("message", e, n, r), this;
  }
  /**
   * Sends a packet.
   *
   * @param {String} type: packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */
  _sendPacket(e, n, r, o) {
    if (typeof n == "function" && (o = n, n = void 0), typeof r == "function" && (o = r, r = null), this.readyState === "closing" || this.readyState === "closed")
      return;
    r = r || {}, r.compress = r.compress !== !1;
    const s = {
      type: e,
      data: n,
      options: r
    };
    this.emitReserved("packetCreate", s), this.writeBuffer.push(s), o && this.once("flush", o), this.flush();
  }
  /**
   * Closes the connection.
   */
  close() {
    const e = () => {
      this._onClose("forced close"), this.transport.close();
    }, n = () => {
      this.off("upgrade", n), this.off("upgradeError", n), e();
    }, r = () => {
      this.once("upgrade", n), this.once("upgradeError", n);
    };
    return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
      this.upgrading ? r() : e();
    }) : this.upgrading ? r() : e()), this;
  }
  /**
   * Called upon transport error
   *
   * @private
   */
  _onError(e) {
    if (Ue.priorWebsocketSuccess = !1, this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening")
      return this.transports.shift(), this._open();
    this.emitReserved("error", e), this._onClose("transport error", e);
  }
  /**
   * Called upon transport close.
   *
   * @private
   */
  _onClose(e, n) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
      if (this.clearTimeoutFn(this._pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), wn && (this._beforeunloadEventListener && removeEventListener("beforeunload", this._beforeunloadEventListener, !1), this._offlineEventListener)) {
        const r = Dt.indexOf(this._offlineEventListener);
        r !== -1 && Dt.splice(r, 1);
      }
      this.readyState = "closed", this.id = null, this.emitReserved("close", e, n), this.writeBuffer = [], this._prevBufferLen = 0;
    }
  }
}
Ue.protocol = lo;
class ca extends Ue {
  constructor() {
    super(...arguments), this._upgrades = [];
  }
  onOpen() {
    if (super.onOpen(), this.readyState === "open" && this.opts.upgrade)
      for (let e = 0; e < this._upgrades.length; e++)
        this._probe(this._upgrades[e]);
  }
  /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */
  _probe(e) {
    let n = this.createTransport(e), r = !1;
    Ue.priorWebsocketSuccess = !1;
    const o = () => {
      r || (n.send([{ type: "ping", data: "probe" }]), n.once("packet", (g) => {
        if (!r)
          if (g.type === "pong" && g.data === "probe") {
            if (this.upgrading = !0, this.emitReserved("upgrading", n), !n)
              return;
            Ue.priorWebsocketSuccess = n.name === "websocket", this.transport.pause(() => {
              r || this.readyState !== "closed" && (u(), this.setTransport(n), n.send([{ type: "upgrade" }]), this.emitReserved("upgrade", n), n = null, this.upgrading = !1, this.flush());
            });
          } else {
            const T = new Error("probe error");
            T.transport = n.name, this.emitReserved("upgradeError", T);
          }
      }));
    };
    function s() {
      r || (r = !0, u(), n.close(), n = null);
    }
    const i = (g) => {
      const T = new Error("probe error: " + g);
      T.transport = n.name, s(), this.emitReserved("upgradeError", T);
    };
    function a() {
      i("transport closed");
    }
    function l() {
      i("socket closed");
    }
    function f(g) {
      n && g.name !== n.name && s();
    }
    const u = () => {
      n.removeListener("open", o), n.removeListener("error", i), n.removeListener("close", a), this.off("close", l), this.off("upgrading", f);
    };
    n.once("open", o), n.once("error", i), n.once("close", a), this.once("close", l), this.once("upgrading", f), this._upgrades.indexOf("webtransport") !== -1 && e !== "webtransport" ? this.setTimeoutFn(() => {
      r || n.open();
    }, 200) : n.open();
  }
  onHandshake(e) {
    this._upgrades = this._filterUpgrades(e.upgrades), super.onHandshake(e);
  }
  /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */
  _filterUpgrades(e) {
    const n = [];
    for (let r = 0; r < e.length; r++)
      ~this.transports.indexOf(e[r]) && n.push(e[r]);
    return n;
  }
}
let la = class extends ca {
  constructor(e, n = {}) {
    const r = typeof e == "object" ? e : n;
    (!r.transports || r.transports && typeof r.transports[0] == "string") && (r.transports = (r.transports || ["polling", "websocket", "webtransport"]).map((o) => ra[o]).filter((o) => !!o)), super(e, r);
  }
};
function fa(t, e = "", n) {
  let r = t;
  n = n || typeof location < "u" && location, t == null && (t = n.protocol + "//" + n.host), typeof t == "string" && (t.charAt(0) === "/" && (t.charAt(1) === "/" ? t = n.protocol + t : t = n.host + t), /^(https?|wss?):\/\//.test(t) || (typeof n < "u" ? t = n.protocol + "//" + t : t = "https://" + t), r = Cn(t)), r.port || (/^(http|ws)$/.test(r.protocol) ? r.port = "80" : /^(http|ws)s$/.test(r.protocol) && (r.port = "443")), r.path = r.path || "/";
  const s = r.host.indexOf(":") !== -1 ? "[" + r.host + "]" : r.host;
  return r.id = r.protocol + "://" + s + ":" + r.port + e, r.href = r.protocol + "://" + s + (n && n.port === r.port ? "" : ":" + r.port), r;
}
const ua = typeof ArrayBuffer == "function", da = (t) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(t) : t.buffer instanceof ArrayBuffer, go = Object.prototype.toString, pa = typeof Blob == "function" || typeof Blob < "u" && go.call(Blob) === "[object BlobConstructor]", ha = typeof File == "function" || typeof File < "u" && go.call(File) === "[object FileConstructor]";
function Bn(t) {
  return ua && (t instanceof ArrayBuffer || da(t)) || pa && t instanceof Blob || ha && t instanceof File;
}
function Bt(t, e) {
  if (!t || typeof t != "object")
    return !1;
  if (Array.isArray(t)) {
    for (let n = 0, r = t.length; n < r; n++)
      if (Bt(t[n]))
        return !0;
    return !1;
  }
  if (Bn(t))
    return !0;
  if (t.toJSON && typeof t.toJSON == "function" && arguments.length === 1)
    return Bt(t.toJSON(), !0);
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && Bt(t[n]))
      return !0;
  return !1;
}
function ma(t) {
  const e = [], n = t.data, r = t;
  return r.data = On(n, e), r.attachments = e.length, { packet: r, buffers: e };
}
function On(t, e) {
  if (!t)
    return t;
  if (Bn(t)) {
    const n = { _placeholder: !0, num: e.length };
    return e.push(t), n;
  } else if (Array.isArray(t)) {
    const n = new Array(t.length);
    for (let r = 0; r < t.length; r++)
      n[r] = On(t[r], e);
    return n;
  } else if (typeof t == "object" && !(t instanceof Date)) {
    const n = {};
    for (const r in t)
      Object.prototype.hasOwnProperty.call(t, r) && (n[r] = On(t[r], e));
    return n;
  }
  return t;
}
function ga(t, e) {
  return t.data = Rn(t.data, e), delete t.attachments, t;
}
function Rn(t, e) {
  if (!t)
    return t;
  if (t && t._placeholder === !0) {
    if (typeof t.num == "number" && t.num >= 0 && t.num < e.length)
      return e[t.num];
    throw new Error("illegal attachments");
  } else if (Array.isArray(t))
    for (let n = 0; n < t.length; n++)
      t[n] = Rn(t[n], e);
  else if (typeof t == "object")
    for (const n in t)
      Object.prototype.hasOwnProperty.call(t, n) && (t[n] = Rn(t[n], e));
  return t;
}
const ya = [
  "connect",
  "connect_error",
  "disconnect",
  "disconnecting",
  "newListener",
  "removeListener"
  // used by the Node.js EventEmitter
], Aa = 5;
var V;
(function(t) {
  t[t.CONNECT = 0] = "CONNECT", t[t.DISCONNECT = 1] = "DISCONNECT", t[t.EVENT = 2] = "EVENT", t[t.ACK = 3] = "ACK", t[t.CONNECT_ERROR = 4] = "CONNECT_ERROR", t[t.BINARY_EVENT = 5] = "BINARY_EVENT", t[t.BINARY_ACK = 6] = "BINARY_ACK";
})(V || (V = {}));
class Ea {
  /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */
  constructor(e) {
    this.replacer = e;
  }
  /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */
  encode(e) {
    return (e.type === V.EVENT || e.type === V.ACK) && Bt(e) ? this.encodeAsBinary({
      type: e.type === V.EVENT ? V.BINARY_EVENT : V.BINARY_ACK,
      nsp: e.nsp,
      data: e.data,
      id: e.id
    }) : [this.encodeAsString(e)];
  }
  /**
   * Encode packet as string.
   */
  encodeAsString(e) {
    let n = "" + e.type;
    return (e.type === V.BINARY_EVENT || e.type === V.BINARY_ACK) && (n += e.attachments + "-"), e.nsp && e.nsp !== "/" && (n += e.nsp + ","), e.id != null && (n += e.id), e.data != null && (n += JSON.stringify(e.data, this.replacer)), n;
  }
  /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */
  encodeAsBinary(e) {
    const n = ma(e), r = this.encodeAsString(n.packet), o = n.buffers;
    return o.unshift(r), o;
  }
}
function Mr(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
class Wn extends $ {
  /**
   * Decoder constructor
   *
   * @param {function} reviver - custom reviver to pass down to JSON.stringify
   */
  constructor(e) {
    super(), this.reviver = e;
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */
  add(e) {
    let n;
    if (typeof e == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      n = this.decodeString(e);
      const r = n.type === V.BINARY_EVENT;
      r || n.type === V.BINARY_ACK ? (n.type = r ? V.EVENT : V.ACK, this.reconstructor = new va(n), n.attachments === 0 && super.emitReserved("decoded", n)) : super.emitReserved("decoded", n);
    } else if (Bn(e) || e.base64)
      if (this.reconstructor)
        n = this.reconstructor.takeBinaryData(e), n && (this.reconstructor = null, super.emitReserved("decoded", n));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + e);
  }
  /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */
  decodeString(e) {
    let n = 0;
    const r = {
      type: Number(e.charAt(0))
    };
    if (V[r.type] === void 0)
      throw new Error("unknown packet type " + r.type);
    if (r.type === V.BINARY_EVENT || r.type === V.BINARY_ACK) {
      const s = n + 1;
      for (; e.charAt(++n) !== "-" && n != e.length; )
        ;
      const i = e.substring(s, n);
      if (i != Number(i) || e.charAt(n) !== "-")
        throw new Error("Illegal attachments");
      r.attachments = Number(i);
    }
    if (e.charAt(n + 1) === "/") {
      const s = n + 1;
      for (; ++n && !(e.charAt(n) === "," || n === e.length); )
        ;
      r.nsp = e.substring(s, n);
    } else
      r.nsp = "/";
    const o = e.charAt(n + 1);
    if (o !== "" && Number(o) == o) {
      const s = n + 1;
      for (; ++n; ) {
        const i = e.charAt(n);
        if (i == null || Number(i) != i) {
          --n;
          break;
        }
        if (n === e.length)
          break;
      }
      r.id = Number(e.substring(s, n + 1));
    }
    if (e.charAt(++n)) {
      const s = this.tryParse(e.substr(n));
      if (Wn.isPayloadValid(r.type, s))
        r.data = s;
      else
        throw new Error("invalid payload");
    }
    return r;
  }
  tryParse(e) {
    try {
      return JSON.parse(e, this.reviver);
    } catch {
      return !1;
    }
  }
  static isPayloadValid(e, n) {
    switch (e) {
      case V.CONNECT:
        return Mr(n);
      case V.DISCONNECT:
        return n === void 0;
      case V.CONNECT_ERROR:
        return typeof n == "string" || Mr(n);
      case V.EVENT:
      case V.BINARY_EVENT:
        return Array.isArray(n) && (typeof n[0] == "number" || typeof n[0] == "string" && ya.indexOf(n[0]) === -1);
      case V.ACK:
      case V.BINARY_ACK:
        return Array.isArray(n);
    }
  }
  /**
   * Deallocates a parser's resources
   */
  destroy() {
    this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
  }
}
class va {
  constructor(e) {
    this.packet = e, this.buffers = [], this.reconPack = e;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */
  takeBinaryData(e) {
    if (this.buffers.push(e), this.buffers.length === this.reconPack.attachments) {
      const n = ga(this.reconPack, this.buffers);
      return this.finishedReconstruction(), n;
    }
    return null;
  }
  /**
   * Cleans up binary packet reconstruction variables.
   */
  finishedReconstruction() {
    this.reconPack = null, this.buffers = [];
  }
}
const ba = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Decoder: Wn,
  Encoder: Ea,
  get PacketType() {
    return V;
  },
  protocol: Aa
}, Symbol.toStringTag, { value: "Module" }));
function Se(t, e, n) {
  return t.on(e, n), function() {
    t.off(e, n);
  };
}
const Ta = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});
class yo extends $ {
  /**
   * `Socket` constructor.
   */
  constructor(e, n, r) {
    super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = e, this.nsp = n, r && r.auth && (this.auth = r.auth), this._opts = Object.assign({}, r), this.io._autoConnect && this.open();
  }
  /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */
  get disconnected() {
    return !this.connected;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */
  subEvents() {
    if (this.subs)
      return;
    const e = this.io;
    this.subs = [
      Se(e, "open", this.onopen.bind(this)),
      Se(e, "packet", this.onpacket.bind(this)),
      Se(e, "error", this.onerror.bind(this)),
      Se(e, "close", this.onclose.bind(this))
    ];
  }
  /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */
  get active() {
    return !!this.subs;
  }
  /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */
  connect() {
    return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
  }
  /**
   * Alias for {@link connect()}.
   */
  open() {
    return this.connect();
  }
  /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */
  send(...e) {
    return e.unshift("message"), this.emit.apply(this, e), this;
  }
  /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */
  emit(e, ...n) {
    var r, o, s;
    if (Ta.hasOwnProperty(e))
      throw new Error('"' + e.toString() + '" is a reserved event name');
    if (n.unshift(e), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile)
      return this._addToQueue(n), this;
    const i = {
      type: V.EVENT,
      data: n
    };
    if (i.options = {}, i.options.compress = this.flags.compress !== !1, typeof n[n.length - 1] == "function") {
      const u = this.ids++, g = n.pop();
      this._registerAckCallback(u, g), i.id = u;
    }
    const a = (o = (r = this.io.engine) === null || r === void 0 ? void 0 : r.transport) === null || o === void 0 ? void 0 : o.writable, l = this.connected && !(!((s = this.io.engine) === null || s === void 0) && s._hasPingExpired());
    return this.flags.volatile && !a || (l ? (this.notifyOutgoingListeners(i), this.packet(i)) : this.sendBuffer.push(i)), this.flags = {}, this;
  }
  /**
   * @private
   */
  _registerAckCallback(e, n) {
    var r;
    const o = (r = this.flags.timeout) !== null && r !== void 0 ? r : this._opts.ackTimeout;
    if (o === void 0) {
      this.acks[e] = n;
      return;
    }
    const s = this.io.setTimeoutFn(() => {
      delete this.acks[e];
      for (let a = 0; a < this.sendBuffer.length; a++)
        this.sendBuffer[a].id === e && this.sendBuffer.splice(a, 1);
      n.call(this, new Error("operation has timed out"));
    }, o), i = (...a) => {
      this.io.clearTimeoutFn(s), n.apply(this, a);
    };
    i.withError = !0, this.acks[e] = i;
  }
  /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */
  emitWithAck(e, ...n) {
    return new Promise((r, o) => {
      const s = (i, a) => i ? o(i) : r(a);
      s.withError = !0, n.push(s), this.emit(e, ...n);
    });
  }
  /**
   * Add the packet to the queue.
   * @param args
   * @private
   */
  _addToQueue(e) {
    let n;
    typeof e[e.length - 1] == "function" && (n = e.pop());
    const r = {
      id: this._queueSeq++,
      tryCount: 0,
      pending: !1,
      args: e,
      flags: Object.assign({ fromQueue: !0 }, this.flags)
    };
    e.push((o, ...s) => r !== this._queue[0] ? void 0 : (o !== null ? r.tryCount > this._opts.retries && (this._queue.shift(), n && n(o)) : (this._queue.shift(), n && n(null, ...s)), r.pending = !1, this._drainQueue())), this._queue.push(r), this._drainQueue();
  }
  /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */
  _drainQueue(e = !1) {
    if (!this.connected || this._queue.length === 0)
      return;
    const n = this._queue[0];
    n.pending && !e || (n.pending = !0, n.tryCount++, this.flags = n.flags, this.emit.apply(this, n.args));
  }
  /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */
  packet(e) {
    e.nsp = this.nsp, this.io._packet(e);
  }
  /**
   * Called upon engine `open`.
   *
   * @private
   */
  onopen() {
    typeof this.auth == "function" ? this.auth((e) => {
      this._sendConnectPacket(e);
    }) : this._sendConnectPacket(this.auth);
  }
  /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */
  _sendConnectPacket(e) {
    this.packet({
      type: V.CONNECT,
      data: this._pid ? Object.assign({ pid: this._pid, offset: this._lastOffset }, e) : e
    });
  }
  /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */
  onerror(e) {
    this.connected || this.emitReserved("connect_error", e);
  }
  /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */
  onclose(e, n) {
    this.connected = !1, delete this.id, this.emitReserved("disconnect", e, n), this._clearAcks();
  }
  /**
   * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
   * the server.
   *
   * @private
   */
  _clearAcks() {
    Object.keys(this.acks).forEach((e) => {
      if (!this.sendBuffer.some((r) => String(r.id) === e)) {
        const r = this.acks[e];
        delete this.acks[e], r.withError && r.call(this, new Error("socket has been disconnected"));
      }
    });
  }
  /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */
  onpacket(e) {
    if (e.nsp === this.nsp)
      switch (e.type) {
        case V.CONNECT:
          e.data && e.data.sid ? this.onconnect(e.data.sid, e.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case V.EVENT:
        case V.BINARY_EVENT:
          this.onevent(e);
          break;
        case V.ACK:
        case V.BINARY_ACK:
          this.onack(e);
          break;
        case V.DISCONNECT:
          this.ondisconnect();
          break;
        case V.CONNECT_ERROR:
          this.destroy();
          const r = new Error(e.data.message);
          r.data = e.data.data, this.emitReserved("connect_error", r);
          break;
      }
  }
  /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */
  onevent(e) {
    const n = e.data || [];
    e.id != null && n.push(this.ack(e.id)), this.connected ? this.emitEvent(n) : this.receiveBuffer.push(Object.freeze(n));
  }
  emitEvent(e) {
    if (this._anyListeners && this._anyListeners.length) {
      const n = this._anyListeners.slice();
      for (const r of n)
        r.apply(this, e);
    }
    super.emit.apply(this, e), this._pid && e.length && typeof e[e.length - 1] == "string" && (this._lastOffset = e[e.length - 1]);
  }
  /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */
  ack(e) {
    const n = this;
    let r = !1;
    return function(...o) {
      r || (r = !0, n.packet({
        type: V.ACK,
        id: e,
        data: o
      }));
    };
  }
  /**
   * Called upon a server acknowledgement.
   *
   * @param packet
   * @private
   */
  onack(e) {
    const n = this.acks[e.id];
    typeof n == "function" && (delete this.acks[e.id], n.withError && e.data.unshift(null), n.apply(this, e.data));
  }
  /**
   * Called upon server connect.
   *
   * @private
   */
  onconnect(e, n) {
    this.id = e, this.recovered = n && this._pid === n, this._pid = n, this.connected = !0, this.emitBuffered(), this.emitReserved("connect"), this._drainQueue(!0);
  }
  /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */
  emitBuffered() {
    this.receiveBuffer.forEach((e) => this.emitEvent(e)), this.receiveBuffer = [], this.sendBuffer.forEach((e) => {
      this.notifyOutgoingListeners(e), this.packet(e);
    }), this.sendBuffer = [];
  }
  /**
   * Called upon server disconnect.
   *
   * @private
   */
  ondisconnect() {
    this.destroy(), this.onclose("io server disconnect");
  }
  /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */
  destroy() {
    this.subs && (this.subs.forEach((e) => e()), this.subs = void 0), this.io._destroy(this);
  }
  /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */
  disconnect() {
    return this.connected && this.packet({ type: V.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }
  /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */
  close() {
    return this.disconnect();
  }
  /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */
  compress(e) {
    return this.flags.compress = e, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */
  get volatile() {
    return this.flags.volatile = !0, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */
  timeout(e) {
    return this.flags.timeout = e, this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */
  onAny(e) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.push(e), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */
  prependAny(e) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(e), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */
  offAny(e) {
    if (!this._anyListeners)
      return this;
    if (e) {
      const n = this._anyListeners;
      for (let r = 0; r < n.length; r++)
        if (e === n[r])
          return n.splice(r, 1), this;
    } else
      this._anyListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAny() {
    return this._anyListeners || [];
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  onAnyOutgoing(e) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(e), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  prependAnyOutgoing(e) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(e), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */
  offAnyOutgoing(e) {
    if (!this._anyOutgoingListeners)
      return this;
    if (e) {
      const n = this._anyOutgoingListeners;
      for (let r = 0; r < n.length; r++)
        if (e === n[r])
          return n.splice(r, 1), this;
    } else
      this._anyOutgoingListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */
  notifyOutgoingListeners(e) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const n = this._anyOutgoingListeners.slice();
      for (const r of n)
        r.apply(this, e.data);
    }
  }
}
function rt(t) {
  t = t || {}, this.ms = t.min || 100, this.max = t.max || 1e4, this.factor = t.factor || 2, this.jitter = t.jitter > 0 && t.jitter <= 1 ? t.jitter : 0, this.attempts = 0;
}
rt.prototype.duration = function() {
  var t = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var e = Math.random(), n = Math.floor(e * this.jitter * t);
    t = Math.floor(e * 10) & 1 ? t + n : t - n;
  }
  return Math.min(t, this.max) | 0;
};
rt.prototype.reset = function() {
  this.attempts = 0;
};
rt.prototype.setMin = function(t) {
  this.ms = t;
};
rt.prototype.setMax = function(t) {
  this.max = t;
};
rt.prototype.setJitter = function(t) {
  this.jitter = t;
};
class kn extends $ {
  constructor(e, n) {
    var r;
    super(), this.nsps = {}, this.subs = [], e && typeof e == "object" && (n = e, e = void 0), n = n || {}, n.path = n.path || "/socket.io", this.opts = n, qt(this, n), this.reconnection(n.reconnection !== !1), this.reconnectionAttempts(n.reconnectionAttempts || 1 / 0), this.reconnectionDelay(n.reconnectionDelay || 1e3), this.reconnectionDelayMax(n.reconnectionDelayMax || 5e3), this.randomizationFactor((r = n.randomizationFactor) !== null && r !== void 0 ? r : 0.5), this.backoff = new rt({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(n.timeout == null ? 2e4 : n.timeout), this._readyState = "closed", this.uri = e;
    const o = n.parser || ba;
    this.encoder = new o.Encoder(), this.decoder = new o.Decoder(), this._autoConnect = n.autoConnect !== !1, this._autoConnect && this.open();
  }
  reconnection(e) {
    return arguments.length ? (this._reconnection = !!e, e || (this.skipReconnect = !0), this) : this._reconnection;
  }
  reconnectionAttempts(e) {
    return e === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = e, this);
  }
  reconnectionDelay(e) {
    var n;
    return e === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = e, (n = this.backoff) === null || n === void 0 || n.setMin(e), this);
  }
  randomizationFactor(e) {
    var n;
    return e === void 0 ? this._randomizationFactor : (this._randomizationFactor = e, (n = this.backoff) === null || n === void 0 || n.setJitter(e), this);
  }
  reconnectionDelayMax(e) {
    var n;
    return e === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = e, (n = this.backoff) === null || n === void 0 || n.setMax(e), this);
  }
  timeout(e) {
    return arguments.length ? (this._timeout = e, this) : this._timeout;
  }
  /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */
  maybeReconnectOnOpen() {
    !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }
  /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */
  open(e) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new la(this.uri, this.opts);
    const n = this.engine, r = this;
    this._readyState = "opening", this.skipReconnect = !1;
    const o = Se(n, "open", function() {
      r.onopen(), e && e();
    }), s = (a) => {
      this.cleanup(), this._readyState = "closed", this.emitReserved("error", a), e ? e(a) : this.maybeReconnectOnOpen();
    }, i = Se(n, "error", s);
    if (this._timeout !== !1) {
      const a = this._timeout, l = this.setTimeoutFn(() => {
        o(), s(new Error("timeout")), n.close();
      }, a);
      this.opts.autoUnref && l.unref(), this.subs.push(() => {
        this.clearTimeoutFn(l);
      });
    }
    return this.subs.push(o), this.subs.push(i), this;
  }
  /**
   * Alias for open()
   *
   * @return self
   * @public
   */
  connect(e) {
    return this.open(e);
  }
  /**
   * Called upon transport open.
   *
   * @private
   */
  onopen() {
    this.cleanup(), this._readyState = "open", this.emitReserved("open");
    const e = this.engine;
    this.subs.push(
      Se(e, "ping", this.onping.bind(this)),
      Se(e, "data", this.ondata.bind(this)),
      Se(e, "error", this.onerror.bind(this)),
      Se(e, "close", this.onclose.bind(this)),
      // @ts-ignore
      Se(this.decoder, "decoded", this.ondecoded.bind(this))
    );
  }
  /**
   * Called upon a ping.
   *
   * @private
   */
  onping() {
    this.emitReserved("ping");
  }
  /**
   * Called with data.
   *
   * @private
   */
  ondata(e) {
    try {
      this.decoder.add(e);
    } catch (n) {
      this.onclose("parse error", n);
    }
  }
  /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */
  ondecoded(e) {
    jt(() => {
      this.emitReserved("packet", e);
    }, this.setTimeoutFn);
  }
  /**
   * Called upon socket error.
   *
   * @private
   */
  onerror(e) {
    this.emitReserved("error", e);
  }
  /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */
  socket(e, n) {
    let r = this.nsps[e];
    return r ? this._autoConnect && !r.active && r.connect() : (r = new yo(this, e, n), this.nsps[e] = r), r;
  }
  /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */
  _destroy(e) {
    const n = Object.keys(this.nsps);
    for (const r of n)
      if (this.nsps[r].active)
        return;
    this._close();
  }
  /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */
  _packet(e) {
    const n = this.encoder.encode(e);
    for (let r = 0; r < n.length; r++)
      this.engine.write(n[r], e.options);
  }
  /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */
  cleanup() {
    this.subs.forEach((e) => e()), this.subs.length = 0, this.decoder.destroy();
  }
  /**
   * Close the current socket.
   *
   * @private
   */
  _close() {
    this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close");
  }
  /**
   * Alias for close()
   *
   * @private
   */
  disconnect() {
    return this._close();
  }
  /**
   * Called when:
   *
   * - the low-level engine is closed
   * - the parser encountered a badly formatted packet
   * - all sockets are disconnected
   *
   * @private
   */
  onclose(e, n) {
    var r;
    this.cleanup(), (r = this.engine) === null || r === void 0 || r.close(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", e, n), this._reconnection && !this.skipReconnect && this.reconnect();
  }
  /**
   * Attempt a reconnection.
   *
   * @private
   */
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const e = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
    else {
      const n = this.backoff.duration();
      this._reconnecting = !0;
      const r = this.setTimeoutFn(() => {
        e.skipReconnect || (this.emitReserved("reconnect_attempt", e.backoff.attempts), !e.skipReconnect && e.open((o) => {
          o ? (e._reconnecting = !1, e.reconnect(), this.emitReserved("reconnect_error", o)) : e.onreconnect();
        }));
      }, n);
      this.opts.autoUnref && r.unref(), this.subs.push(() => {
        this.clearTimeoutFn(r);
      });
    }
  }
  /**
   * Called upon successful reconnect.
   *
   * @private
   */
  onreconnect() {
    const e = this.backoff.attempts;
    this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", e);
  }
}
const ht = {};
function Wt(t, e) {
  typeof t == "object" && (e = t, t = void 0), e = e || {};
  const n = fa(t, e.path || "/socket.io"), r = n.source, o = n.id, s = n.path, i = ht[o] && s in ht[o].nsps, a = e.forceNew || e["force new connection"] || e.multiplex === !1 || i;
  let l;
  return a ? l = new kn(r, e) : (ht[o] || (ht[o] = new kn(r, e)), l = ht[o]), n.query && !e.query && (e.query = n.queryKey), l.socket(n.path, e);
}
Object.assign(Wt, {
  Manager: kn,
  Socket: yo,
  io: Wt,
  connect: Wt
});
function _a(t) {
  const e = We(), n = xe();
  if (!e || !n) {
    console.error(
      "ERR CREATING WEBSOCKET: Access token or thread ID is missing"
    );
    return;
  }
  const r = navigator.userAgent.toLowerCase().includes("firefox");
  return Wt(t, {
    auth: {
      thread_id: n,
      token: e
    },
    perMessageDeflate: void 0,
    transports: r ? ["polling", "websocket"] : ["websocket"]
  });
}
async function xa(t, e) {
  const n = xe();
  if (!n)
    throw new Error("Thread ID is missing");
  const r = We(), s = `${e ? "/" : t}api/messages/list/${n}`;
  return await fetch(s, {
    credentials: "include",
    headers: {
      Authorization: r ? `Bearer ${r}` : "",
      "Content-Type": "application/json"
    }
  });
}
const Sa = "data:audio/ogg;base64,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";
function Lr() {
  new Audio(Sa).play().catch((e) => {
    console.error(J.errors.notificationSoundError, e);
  });
}
const Ao = {
  chatClosedByAgent: !1,
  error: void 0,
  hasNewMessages: !1,
  initiatorId: "",
  isChatOpen: !1,
  isOutsideWorkingHours: !1,
  lastReadMessageId: void 0,
  loading: !1,
  messages: [],
  shouldShowWelcome: !0,
  socket: void 0,
  socketError: void 0
};
function Ca({
  apiUrl: t,
  children: e,
  initiatorId: n,
  name: r,
  organisationId: o,
  socketUrl: s,
  useProxy: i = !1
}) {
  const [a, l] = ko(wa, Ao), f = Le(a), u = ct(() => {
    var v, x;
    (v = f.current.socket) == null || v.removeAllListeners(), (x = f.current.socket) == null || x.disconnect(), l({ payload: void 0, type: Q.SET_SOCKET }), l({ payload: !0, type: Q.SHOW_WELCOME_SCREEN });
  }, [l]), g = ct(() => {
    var x;
    if ((x = f.current.socket) != null && x.connected)
      return;
    const v = _a(s);
    if (!v) {
      Z.error(J.errors.unableToInitializeChat);
      return;
    }
    return l({ payload: v, type: Q.SET_SOCKET }), v.on(Fe.CONNECT, () => {
      const p = f.current.isChatOpen;
      if (!f.current.chatClosedByAgent) {
        const y = xe(), E = {
          id: Date.now().toString(),
          is_read_by_initiator: p,
          is_received: !0,
          sender_id: "system",
          sender_type: Be.System,
          text: J.chatProvider.connected,
          thread_id: y ?? ""
        };
        l({
          payload: E,
          type: Q.ADD_MESSAGE
        }), xi(v, { thread_id: y ?? "" }), Or(v, {
          thread_id: y ?? "",
          user_id: n
        });
      }
    }), v.on(Fe.DISCONNECT, () => {
      const p = xe(), y = f.current.isChatOpen;
      if (!f.current.chatClosedByAgent) {
        const E = {
          id: Date.now().toString(),
          is_read_by_initiator: y,
          is_received: !0,
          sender_id: "system",
          sender_type: Be.System,
          text: J.chatProvider.disconnected,
          thread_id: p ?? ""
        };
        l({
          payload: E,
          type: Q.ADD_MESSAGE
        }), Or(v, {
          thread_id: p ?? "",
          user_id: n
        });
      }
    }), v.on(Fe.MESSAGE, (p) => {
      const y = f.current.isChatOpen;
      if (p.sender_type === Be.Agent) {
        Lr();
        const E = We(), d = xe();
        if (!d || !E)
          return;
        Ci(v, {
          message_id: p.id,
          thread_id: d
        }), y && Si(v, {
          access_token: E,
          thread_id: d
        });
      }
      l({
        payload: { ...p, is_read_by_initiator: y },
        type: Q.ADD_MESSAGE
      });
    }), v.on(Fe.ERROR, (p) => {
      console.error(J.errors.websocketError, p), l({
        payload: J.errors.chatConnectionError,
        type: Q.SET_ERROR
      });
    }), v.on(Fe.CHAT_CLOSED, () => {
      const p = {
        id: Date.now().toString(),
        is_read_by_initiator: !1,
        is_received: !0,
        sender_id: "system",
        sender_type: Be.System,
        text: J.chatProvider.chatClosedByAgent,
        thread_id: xe() ?? ""
      };
      l({
        payload: p,
        type: Q.CHAT_CLOSED_BY_AGENT
      });
    }), v.on(
      Fe.MESSAGE_RECEIVED,
      (p) => {
        l({
          payload: p,
          type: Q.SET_MESSAGE_AS_RECEIVED_BY_AGENT
        });
      }
    ), () => {
      v.disconnect();
    };
  }, [s, n]), T = ct(async () => {
    const v = We();
    if (!(!xe() || !v)) {
      l({ payload: !0, type: Q.SET_LOADING });
      try {
        const p = await xa(t, i);
        if (p.status !== 200) {
          console.error(J.errors.fetchHistoryFailed), Z.error(J.errors.fetchHistoryError), ro(), u();
          return;
        }
        const y = await p.json();
        l({ payload: y, type: Q.SET_MESSAGES }), l({ payload: !1, type: Q.SHOW_WELCOME_SCREEN });
      } catch (p) {
        console.error(J.errors.fetchHistoryError, p), Z.error(J.errors.fetchHistoryError);
      } finally {
        l({ payload: !1, type: Q.SET_LOADING });
      }
    }
  }, [t, u]), R = ct(
    (v) => {
      var E;
      const x = We(), p = xe();
      if (!p || !x) {
        console.error(J.errors.missingThreadOrToken);
        return;
      }
      if (!((E = f.current.socket) != null && E.connected)) {
        console.error(J.errors.websocketNotConnected);
        return;
      }
      const y = {
        id: Date.now().toString(),
        is_read_by_initiator: !0,
        is_received: !1,
        sender_id: n,
        sender_type: Be.Initiator,
        text: v,
        thread_id: p
      };
      wi(f.current.socket, {
        ...y,
        access_token: x,
        sender_type: Be.Initiator
      });
    },
    [n]
  ), P = ct(async () => {
    f.current.socket && (f.current.socket.removeAllListeners(), f.current.socket.disconnect());
    const v = xe(), x = We();
    if (v && x) {
      await T(), l({ payload: !1, type: Q.SHOW_WELCOME_SCREEN });
      return;
    }
    const p = await Ri({
      apiUrl: t,
      initiatorId: n,
      name: r,
      organisationId: o,
      useProxy: i
    });
    p.status === 200 || p.status === 201 ? p.threadId && p.accessToken && (Oi(p.threadId, p.accessToken), g(), l({ payload: !1, type: Q.SHOW_WELCOME_SCREEN })) : p.error === "Outside working hours" ? l({ payload: !0, type: Q.SET_OUTSIDE_WORKING_HOURS }) : l({
      payload: p.error ?? J.errors.failedToInitializeChat,
      type: Q.SET_ERROR
    });
  }, [
    t,
    g,
    n,
    T,
    r,
    o
  ]);
  ze(() => {
    var p;
    const v = xe(), x = We();
    return v && x && !((p = a.socket) != null && p.connected) && g(), l({
      payload: !(v && x),
      type: Q.SHOW_WELCOME_SCREEN
    }), () => {
      u();
    };
  }, []), ze(() => {
    a.isChatOpen && T();
  }, [T, a.isChatOpen]), ze(() => {
    f.current = a;
  }, [a]);
  const O = Io(
    () => {
      var v;
      return {
        ...a,
        dispatch: l,
        handleStartChat: P,
        initializeWebSocket: g,
        initiatorId: n,
        isConnected: ((v = f.current.socket) == null ? void 0 : v.connected) ?? !1,
        loadMessageHistory: T,
        playNotificationSound: Lr,
        sendMessage: R
      };
    },
    [
      a,
      n,
      R,
      g,
      T,
      P
    ]
  );
  return /* @__PURE__ */ W(Kr.Provider, { value: O, children: e });
}
var Q = /* @__PURE__ */ ((t) => (t.ADD_MESSAGE = "ADD_MESSAGE", t.CHAT_CLOSED_BY_AGENT = "CHAT_CLOSED_BY_AGENT", t.HAS_NEW_MESSAGES = "HAS_NEW_MESSAGES", t.SET_ERROR = "SET_ERROR", t.SET_LOADING = "SET_LOADING", t.SET_MESSAGE_AS_RECEIVED_BY_AGENT = "SET_MESSAGE_AS_RECEIVED_BY_AGENT", t.SET_MESSAGES = "SET_MESSAGES", t.SET_OUTSIDE_WORKING_HOURS = "SET_OUTSIDE_WORKING_HOURS", t.SET_SOCKET = "SET_SOCKET", t.SET_SOCKET_ERROR = "SET_SOCKET_ERROR", t.SHOW_WELCOME_SCREEN = "SHOW_WELCOME_SCREEN", t.TOGGLE_CHAT = "TOGGLE_CHAT", t))(Q || {});
function wa(t, e) {
  var n, r, o, s;
  switch (e.type) {
    case "ADD_MESSAGE":
      return t.messages.some((i) => i.id === e.payload.id) ? t : {
        ...t,
        hasNewMessages: !t.isChatOpen,
        messages: [...t.messages, e.payload]
      };
    case "CHAT_CLOSED_BY_AGENT":
      return t.messages.some((i) => i.id === e.payload.id) ? t : {
        ...t,
        chatClosedByAgent: !0,
        messages: [...t.messages, e.payload]
      };
    case "HAS_NEW_MESSAGES": {
      let i = [...t.messages];
      return e.payload || (i = i.map((a) => ({
        ...a,
        is_read_by_initiator: !0
      }))), {
        ...t,
        messages: i
      };
    }
    case "SET_ERROR":
      return { ...t, error: e.payload ?? void 0 };
    case "SET_LOADING":
      return { ...t, loading: e.payload };
    case "SET_MESSAGE_AS_RECEIVED_BY_AGENT": {
      const { message_id: i } = e.payload, a = t.messages.findIndex(
        (f) => f.id === i
      );
      if (a === -1)
        return console.warn(`Message with ID ${i} not found in state.`), t;
      const l = [...t.messages];
      return l[a] = {
        ...l[a],
        is_read_by_initiator: t.isChatOpen,
        is_received: !0
      }, {
        ...t,
        messages: l
      };
    }
    case "SET_MESSAGES":
      return {
        ...t,
        messages: e.payload
      };
    case "SET_OUTSIDE_WORKING_HOURS":
      return { ...t, isOutsideWorkingHours: e.payload };
    case "SET_SOCKET":
      return { ...t, socket: e.payload ?? void 0 };
    case "SET_SOCKET_ERROR":
      return { ...t, socketError: e.payload ?? void 0 };
    case "SHOW_WELCOME_SCREEN":
      return { ...t, shouldShowWelcome: e.payload };
    case "TOGGLE_CHAT": {
      let i = t.hasNewMessages;
      const a = e.payload;
      let l = t.lastReadMessageId, f = [...t.messages];
      if (a) {
        if (t.chatClosedByAgent)
          return ro(), (n = t.socket) == null || n.removeAllListeners(), (r = t.socket) == null || r.disconnect(), {
            ...Ao
          };
        i = !1, (o = t.socket) == null || o.emit(no.MARK_ALL_MESSAGES_AS_READ, {
          access_token: We(),
          thread_id: xe()
        }), f = f.map((u) => ({
          ...u,
          is_read_by_initiator: !0
        }));
      } else
        l = (s = f[f.length - 1]) == null ? void 0 : s.id;
      return {
        ...t,
        hasNewMessages: i,
        isChatOpen: a,
        lastReadMessageId: l,
        messages: f
      };
    }
    default:
      return t;
  }
}
function Oa() {
  const { dispatch: t, hasNewMessages: e, isChatOpen: n } = nt();
  return /* @__PURE__ */ W(
    Ra,
    {
      $isChatOpen: n,
      $showNotificationDot: e,
      onClick: () => {
        t({ payload: !n, type: Q.TOGGLE_CHAT });
      },
      children: n ? /* @__PURE__ */ W("img", { alt: "close icon", src: Ti }) : /* @__PURE__ */ W("img", { alt: "chat icon", src: _i })
    }
  );
}
const Ra = te.button`
  position: fixed;
  bottom: 30px;
  right: 35px;
  height: 75px;
  width: 75px;
  border: none;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--general-color, magenta);
  transition: all 0.2s ease, transform 0.3s ease;

  transform: ${({ $isChatOpen: t }) => t ? "rotate(90deg)" : "none"};

  ${({ $showNotificationDot: t }) => t && `
        &::after {
            content: '';
            position: absolute;
            top: 4px;
            left: 4px;
            width: 12px;
            height: 12px;
            background: #ff0000;
            border-radius: 50%;
            border: 3px solid white;
        }
    `}
`, ka = No`
    :root {
        --general-color: ${(t) => t.generalColor};
        --message-outgoing-color: ${(t) => t.outgoingColor};
        --message-incoming-color: ${(t) => t.incomingColor};
    }
`;
function Da({
  apiUrl: t,
  generalColor: e,
  imageUrl: n,
  initiatorId: r,
  messageIncomingColor: o,
  messageOutgoingColor: s,
  name: i,
  organisationId: a,
  socketUrl: l,
  useProxy: f = !1
}) {
  return /* @__PURE__ */ Oe(
    Ca,
    {
      apiUrl: t,
      initiatorId: r,
      name: i,
      organisationId: a,
      socketUrl: l,
      useProxy: f,
      children: [
        /* @__PURE__ */ W(
          ka,
          {
            generalColor: e,
            incomingColor: o,
            outgoingColor: s
          }
        ),
        /* @__PURE__ */ W(Oa, {}),
        /* @__PURE__ */ W(Ei, { imageUrl: n })
      ]
    }
  );
}
export {
  Da as ChatWidget
};
